/*HELPER*/
// Defined namespace for theme
var SHTHelper = window.SHTHelper || {};

var TRAP_FOCUS_HANDLERS = {};

SHTHelper.fetchConfigHTTP = {
  method: "POST",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/javascript",
  },
};

SHTHelper.fetchConfigJSON = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

SHTHelper.fetchConfig = {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
};

SHTHelper.debounce = function (fn, delay) {
  let id = null;
  return function (args) {
    clearTimeout(id);
    id = null;
    id = setTimeout(function () {
      fn.call(this, args);
    }, delay);
  };
};

SHTHelper.removeTrapFocus = function (elementToFocus = null) {
  document.removeEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin);
  document.removeEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout);
  document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);

  if (elementToFocus) elementToFocus.focus();
};

SHTHelper.trapFocus = function (element, elementToFocus = element) {
  //let headerLogoLink = SHTHelper.qs(".js-header-logo-link");
  let focusableEls = element.querySelectorAll(`a[href]:not([disabled]), [tabindex]:not([tabindex^='-']), summary, button:not([disabled]), textarea:not([disabled]), input:not([type=hidden]):enabled, input[type="text"]:not([disabled]), object, iframe, input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])`);

  let firstFocusableEl = focusableEls[0];

  let lastFocusableEl = focusableEls[focusableEls.length - 1];

  // if (focusableEls.length === 1 && headerLogoLink) {
  //   lastFocusableEl = headerLogoLink;
  // }

  let KEYCODE_TAB = 9;
  //firstFocusableEl.focus();

  SHTHelper.removeTrapFocus();

  TRAP_FOCUS_HANDLERS.focusin = event => {
    if (event.target !== element && event.target !== lastFocusableEl && event.target !== firstFocusableEl) return;

    document.addEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
  };

  TRAP_FOCUS_HANDLERS.focusout = function () {
    document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
  };

  TRAP_FOCUS_HANDLERS.keydown = function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      if (e.target === element || e.target === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  };

  document.addEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout);
  document.addEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin);

  elementToFocus.focus();
};

SHTHelper.isColor = function (strColor) {
  let s = new Option().style;
  s.color = strColor;
  return s.color == strColor;
};

SHTHelper.isHexColor = function (color) {
  return /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(color);
};

SHTHelper.isImage = function (url) {
  return /(\/\/)([^\s(["<,>/]*)(\/)[^\s[",><]*(.png|.jpg|.webp|.heic|.gif|.svg)(\?[^\s[",><]*)?/gi.test(url);
};

SHTHelper.preventStickyHeaderReveal = function () {
  let stickyHeader = SHTHelper.qs("sht-sticky-header");
  stickyHeader && stickyHeader.dispatchEvent(new Event("preventStickyHeaderReveal"));
};


SHTHelper.loadScript = function (id, file, callback) {
  if (!SHTHelper.qs(`#${id}`)) {
    let script = document.createElement("script");
    script.setAttribute("src", `${file}`);
    script.setAttribute("id", `${id}`);
    script.onload = function () {
      callback();
    };
    script.onreadystatechange = function () {
      if (this.readyState == "complete" || this.readyState == "loaded") {
        callback();
      }
    };
    script.onerror = function (event) {
      console.log("Failed to load script file " + file, event);
      callback();
    };
    document.body.appendChild(script);
  } else {
    callback();
  }
};

SHTHelper.forceUpdateCartStatus = function (res) {
  let sections = [
    {
      section: "cart-drawer",
      selector: `.js-cart-drawer-wrapper`,
      space_selector: `.js-cart-drawer-wrapper`,
    },
    {
      section: "header-cart-status",
      space_selector: `.shopify-section`,
      selector: `#headerCartStatus`,
      cart_notification: false,
    },
    {
      section: "main-cart",
      space_selector: `#mainCartContainer`,
      selector: `#mainCartContainer`,
      cart_notification: false,
    },
    {
      section: "cart-notification-panel-product",
      space_selector: `.js-cart-notification-panel-item-count`,
      selector: `.js-cart-notification-panel-item-count-content`,
      cart_notification: false,
    },
    {
      section: "cart-notification-panel-product",
      space_selector: `.js-cart-notification-panel-product-${res?.id}`,
      selector: `.js-cart-notification-panel-content`,
      cart_notification: true,
    },
  ];

  let cartNotification = SHTHelper.qs("sht-cart-noti");
  let stickyHeader = SHTHelper.qs("sht-sticky-header");

  let sectionsToStr = sections.map(section => section.section).join(",");

  fetch(`${window.location.pathname}?sections=${sectionsToStr}`)
    .then(response => {
      return response.json();
    })
    .then(json => {
      // if (stickyHeader) {
      //   if (stickyHeader.dataset.isEnabled) {
      //     stickyHeader.reveal();
      //   }
      // }
      sections.forEach(e => {
        let sectionHtml = json[e.section];
        let shouldBeUpdateElm = SHTHelper.qs(e.selector);
        if (sectionHtml && shouldBeUpdateElm) {
          let newElm = new DOMParser().parseFromString(sectionHtml, "text/html").querySelector(e.space_selector);
          if (newElm) {
            shouldBeUpdateElm.innerHTML = newElm.innerHTML;
          }

          if (e.cart_notification && cartNotification) {
            cartNotification.open();
          }
        }
      });
    })
    .catch(e => {
      console.log("Cannot force Update Cart Status");
    });
};

class SHTElementLazyLoad {
  constructor() {
    this.elements = SHTHelper.qsa(".js-main-body .js-animate");
    this.sequential_elements = SHTHelper.qsa(".js-main-body .js-seq-animate");
    //this.index = 1;
    this.setupEventListeners();
  }

  setupEventListeners() {
    let observer = new IntersectionObserver((entries, observer) => {
      for (let i = 0, n = entries.length; i < n; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add("animated");
          observer.unobserve(entries[i].target);
        }
      }
    });

    for (let i = 0, n = this.elements.length; i < n; i++) {
      observer.observe(this.elements[i]);
    }

    let sequentialObserver = new IntersectionObserver(
      (entries, observer) => {
        for (let i = 0, n = entries.length; i < n; i++) {
          let index = i * 100;
          if (entries[i].isIntersecting) {
            setTimeout(() => {
              entries[i].target.classList.add("animated");
            }, index);
            observer.unobserve(entries[i].target);
          }
        }
      },
      {
        threshold: 0.2,
      }
    );

    for (let i = 0, n = this.sequential_elements.length; i < n; i++) {
      sequentialObserver.observe(this.sequential_elements[i]);
    }
  }
}
setTimeout(() => {
  typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
  });
}

class SHTCustomComponent extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }
}

class SHTLazyLoadingVideo extends SHTCustomComponent {
  constructor() {
    super();
    this.video = this.$("iframe");
    this.isLoaded = false;
    this.isPlaying = false;
    this.addObserver();
  }

  loadVideo() {
    if (this.video && !this.isLoaded) {
      this.video.setAttribute("src", this.video.getAttribute("data-src"));
      this.isLoaded = true;

      this.video.addEventListener("load", () => {
        this.dispatchEvent(
          new CustomEvent("loadingEnd", {
            detail: {
              ele: this.video,
              parent: this,
            },
          })
        );
      });
    }

    if (this.dataVideoType == "local_video" && !this.isLoaded) {
      this.local_video = this.$("video");
      let video_src = this.local_video.querySelector("source").getAttribute("data-src");
      this.local_video.src = video_src;
      this.isLoaded = true;
    }
  }

  playVideo() {
    if (!this.isPlaying && this.isLoaded) {
      if (this.dataVideoType == "youtube") {
        this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
      } else if (this.dataVideoType == "vimeo") {
        this.video.contentWindow.postMessage('{"method":"play"}', "*");
      } else if (this.dataVideoType == "local_video") {
        this.local_video?.play();
      }
      this.isPlaying = true;
    }
  }

  execute() {
    this.addObserver();
  }

  addObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadVideo();
          this.playVideo();
        } else {
          this.pauseVideo();
          this.isPlaying = false;
        }
      });
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(this);
  }

  pauseVideo() {
    if (this.isPlaying) {
      this.$(".js-media-item-youtube")?.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
      this.$(".js-media-item-vimeo")?.contentWindow.postMessage('{"method":"pause"}', "*");
      this.$(".js-media-item-video")?.pause();
      this.isPlaying = false;
    }
  }

  static get observedAttributes() {
    return ["data-video-type", "data-video-id"];
  }

  set dataVideoType(newValue) {
    this.setAttribute("data-video-type", newValue);
  }

  get dataVideoType() {
    return this.getAttribute("data-video-type");
  }

  set dataVideoId(newValue) {
    this.setAttribute("data-video-id", newValue);
  }

  get dataVideoId() {
    return this.getAttribute("data-video-id");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.execute();
    }
  }

  connectedCallback() {
    this.execute();
  }

  disconnectedCallback() {}
}
customElements.define("sht-load-video", SHTLazyLoadingVideo);

/* Slideshow */
class SHTSlideShow extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    // this.$$ = this.querySelectorAll.bind(this);
    this.slideshow = this.$(".js-slideshow");
    this.slideshowItems = this.$(".js-slideshow-items");
    this.totalElm = this.$(".js-slideshow-total");
    this.currentElm = this.$(".js-slideshow-current");
    this.separatorElm = this.$(".js-slideshow-separator");
    this.prevBtn = this.$(".js-slideshow-prev-btn");
    this.nextBtn = this.$(".js-slideshow-next-btn");
    this.startNStopBtn = this.$(".js-slideshow-start-n-stop-btn");
    this.imageItems = this.$$(".js-slideshow-image");
    this.pauseIcon = this.startNStopBtn.querySelector(".js-slideshow-pause-icon");
    this.playIcon = this.startNStopBtn.querySelector(".js-slideshow-play-icon");
    this.properties = JSON.parse(this.dataset.slideshowProperties);

    this.autoplay = this.properties.autoplay || false;
    this.image = null;
    this.template = null;
    this.current = 1;
    this.anchors = [];
    this.lastScrollTimeout = null;
    this.autoplayInterval = null;
    this.images = this.slideshowItems.children;
    this.total = this.images.length;
    this.slideshowItems.scrollLeft = 0;
    this.observer = null;
    this.isPaused = false;
    this.pagination = this.$(".js-slideshow-pagination");
    this.pagination_items = this.pagination?.querySelectorAll(".js-slideshow-pagination-item");
  }
  cloneSlideItem() {
    if (this.total == 2) {
      let firstItem = this.slideshowItems.querySelector(`.js-slideshow-item:first-of-type`);
      let lastItem = this.slideshowItems.querySelector(`.js-slideshow-item:last-of-type`);
      if (lastItem) {
        let clonedItem = lastItem.cloneNode(true);
        clonedItem.classList.add("slider-slide--clone");
        this.slideshowItems.append(clonedItem);
      }
      if (firstItem) {
        let clonedItem = firstItem.cloneNode(true);
        clonedItem.classList.add("slider-slide--clone");
        this.slideshowItems.append(clonedItem);
      }
    }
  }
  execute() {
    this.cloneSlideItem();
    this.prepare();
    this.bindEventHandlers();
    this.init();
  }
  connectedCallback() {
    this.execute();
  }
  init() {
    if (this.autoplay) {
      this.resumeAutoPlay();
      this.isPaused = true;
    }
    this.updateSort();
  }
  updateSort() {
    if (this.total <= 1) return;

    let scrollLeftB = this.slideshowItems.scrollLeft;
    let scrollLeft = Math.round(scrollLeftB);
    let offsetWidth = this.slideshowItems.offsetWidth;
    let scrollWidth = this.slideshowItems.scrollWidth;
    if (scrollLeft < offsetWidth) {
      this.slideshowItems.prepend(this.images[this.total - 1]);
      this.slideshowItems.scrollLeft = scrollLeft + offsetWidth;
    }
    if (Math.floor(scrollWidth - scrollLeftB) <= offsetWidth) {
      this.slideshowItems.append(this.images[0]);
      this.slideshowItems.scrollLeft = scrollLeft - offsetWidth;
    }
  }
  startAutoPlay() {
    if (this.autoplay) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = setInterval(
        function () {
          this.nextSlide();
        }.bind(this),
        this.properties.duration
      );
    }
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.slideshowItems.addEventListener(
      "wheel",
      function (evt) {
        if (Math.abs(evt.deltaX) == 5) {
          this.stopAutoPlay();
        }
      }.bind(this),
      {
        passive: true,
      }
    );
    this.slideshowItems.addEventListener("scroll", SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100));
    this.nextBtn.addEventListener(
      "click",
      function () {
        this.nextSlide();
        this.stopAutoPlay();
      }.bind(this)
    );
    this.prevBtn.addEventListener(
      "click",
      function () {
        this.prevSlide();

        this.stopAutoPlay();
      }.bind(this)
    );
    this.startNStopBtn.addEventListener("click", this.onStartNStopEventHandle.bind(this));
  }
  onStartNStopEventHandle(e) {
    e.preventDefault();
    if (this.autoplay) {
      this.stopAutoPlay();
      // this.resumePaginationProgressBar(false);
    } else {
      this.resumeAutoPlay();
      //this.resumePaginationProgressBar(true);
    }
  }
  stopAutoPlay() {
    clearInterval(this.autoplayInterval);

    this.pauseIcon.classList.add("d-none");
    this.playIcon.classList.remove("d-none");

    this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]);
    this.slideshowItems.setAttribute("aria-live", "polite");
    this.autoplay = false;
  }
  resumeAutoPlay() {
    this.autoplay = true;

    this.pauseIcon.classList.remove("d-none");
    this.playIcon.classList.add("d-none");

    this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[1]);
    this.slideshowItems.setAttribute("aria-live", "off");
    this.startAutoPlay();
  }
  onScrollEventHandle(e) {
    e.preventDefault();
    if (this.lastScrollTimeout) {
      clearTimeout(this.lastScrollTimeout);
    }
    this.lastScrollTimeout = setTimeout(
      function () {
        this.updateSort();
      }.bind(this),
      100
    );
    this.updateCurrent();
    this.updatePagination();
  }

  // resumePaginationProgressBar(status) {
  //   if (this.pagination) {
  //     let item = this.pagination.querySelector(
  //       `li[data-slideshow-index="${this.current}"]`
  //     );

  //     if (status) {
  //       item
  //         .querySelector(".js-slideshow-pagination-item-background")
  //         .style.setProperty("width", "0%");
  //       item
  //         .querySelector(".js-slideshow-pagination-item-background")
  //         .getAnimations()
  //         .forEach((anim) => {
  //           anim.cancel();
  //           anim.play();
  //         });
  //     } else {
  //       item
  //         .querySelector(".js-slideshow-pagination-item-background")
  //         .getAnimations()
  //         .forEach((anim) => {
  //           anim.pause();
  //         });
  //     }
  //   }
  // }

  updatePagination() {
    if (this.pagination) {
      let item = this.pagination.querySelector(`li[data-slideshow-index="${this.current}"]`);
      if (item) {
        // let items = this.pagination.querySelectorAll(
        //   ".js-slideshow-pagination-item"
        // );
        this.pagination_items.forEach(el => el.classList.remove("is-active"));

        // if (this.autoplay) {
        //   item.style.setProperty(
        //     "--delay",
        //     this.properties.duration ? `${this.properties.duration}ms` : "0s"
        //   );
        // }

        item.classList.add("is-active");
      }
    }
  }
  prepare() {
    this.totalElm.textContent = this.total;
    this.currentElm.textContent = this.current;
    this.separatorElm.textContent = this.properties.separatorText;
    if (this.autoplay) {
      this.startNStopBtn.toggleAttribute("hidden", false);
      this.startNStopBtn.querySelector(".js-slideshow-pause-icon").classList.remove("d-none");
      //this.startNStopBtn.textContent = this.properties.autoplayText[1];
      this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]);
      this.slideshowItems.setAttribute("aria-live", "off");
    }
  }
  updateCurrent() {
    let currentItem = this.$(".js-slideshow-image--current");
    if (currentItem) {
      this.current = currentItem.dataset.slideshowIndex;
    }
    this.currentElm.textContent = this.current;
  }
  prevSlide() {
    if (Shopify.designMode) {
      this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
    } else {
      let currentItem = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
      currentItem && currentItem.classList.add("slider-slide--active-blur");

      setTimeout(() => {
        this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth;
        currentItem.classList.remove("slider-slide--active-blur");
      }, 200);
    }
  }
  nextSlide() {
    if (Shopify.designMode) {
      this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
    } else {
      let currentItem = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
      currentItem && currentItem.classList.add("slider-slide--active-blur");

      setTimeout(() => {
        this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth;
        currentItem.classList.remove("slider-slide--active-blur");
      }, 200);
    }
  }
  observerSlideShow() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.dataset.viewport = 1;
          }
          this.observer.unobserve(this);
          // if (entry.isIntersecting && !this.isPaused) {
          //   this.resumeAutoPlay();
          //   this.isPaused = true;
          // } else {
          //   this.stopAutoPlay();
          //   this.isPaused = false;
          // }
        });
      },
      { threshold: 0.15 }
    );
    this.observer.observe(this);
  }
}
customElements.define("sht-slideshow", SHTSlideShow);

class SHTSlideshowLazyLoadingImage extends SHTCustomComponent {
  constructor() {
    super();
    this.image = this.$(".js-image-lazy");
    this.imageMobile = this.$(".js-image-lazy-mobile");
    this.spinner = this.$(".js-image-lazy-spinner");
    this.container = this.closest(".js-slideshow-items");
    this.currentItemClass = "js-slideshow-image--current";
    this.slideItem = this.closest(".js-slideshow-item");
    this.sectionId = this.dataset.sectionId;
    this.section = SHTHelper.qs(`#shopify-section-${this.sectionId}`);

    this.bindEventHandlers();
  }

  setSlideItemVisibility(flag) {
    if (!flag) {
      this.slideItem.setAttribute("aria-hidden", "true");
      this.slideItem.setAttribute("tabindex", "-1");

      this.slideItem.classList.remove("slider-slide--active");
    } else {
      this.slideItem.setAttribute("aria-hidden", "false");
      this.slideItem.removeAttribute("tabindex");
      this.slideItem.classList.add("slider-slide--active");
    }
  }

  observeImage(primaryImage, secondaryImage) {
    let imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          let target = entry.target;
          let parentNode = this.parentNode;

          if (entry.isIntersecting && !this.getAttribute("loaded")) {
            primaryImage && primaryImage.removeAttribute("loading");
            secondaryImage && secondaryImage.removeAttribute("loading");
            this.setAttribute("loaded", true);
            parentNode.classList.add(this.currentItemClass);
            this.setSlideItemVisibility(true);
          } else if (entry.intersectionRatio == 0) {
            parentNode.classList.remove(this.currentItemClass);
            this.setSlideItemVisibility(false);
          } else {
            if (this.getAttribute("loaded")) {
              parentNode.classList.add(this.currentItemClass);
              this.setSlideItemVisibility(true);
            }
          }
        });
      },
      {
        root: this.container,
        rootMargin: `100px -2px 100px -2px`,
        threshold: 0,
      }
    );
    primaryImage && imageObserver.observe(primaryImage);
  }

  loadImage() {
    let resizeObserver = new ResizeObserver(entries => {
      if (!window.matchMedia("(max-width: 767px)").matches) {
        this.image && this.observeImage(this.image, this.imageMobile);
      } else {
        if (this.imageMobile) {
          this.observeImage(this.imageMobile, this.image);
        } else {
          this.image && this.observeImage(this.image, this.imageMobile);
        }
      }
    });

    resizeObserver.observe(document.body);

    if (!window.matchMedia("(max-width: 767px)").matches) {
      this.image && this.observeImage(this.image, this.imageMobile);
    } else {
      if (this.imageMobile) {
        this.observeImage(this.imageMobile, this.image);
      } else {
        this.image && this.observeImage(this.image, this.imageMobile);
      }
    }
  }

  bindEventHandlers() {}

  execute() {
    this.loadImage();
  }

  connectedCallback() {
    this.execute();
  }

  disconnectedCallback() {}
}

customElements.define("sht-slideshow-load-img", SHTSlideshowLazyLoadingImage);

class SHTSlideshowCTA extends SHTCustomComponent {
  constructor() {
    super();
    //this.$$ = this.querySelectorAll.bind(this);
    this.ctaButton = this.$$(".js-slideshow-cta");
    this.container = this.closest(".js-slideshow-items");
    this.bindEventHandlers();
  }
  bindEventHandlers() {
    this.observeItem();
  }
  observeItem() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.setCTAVisibility(true);
          } else {
            this.setCTAVisibility(false);
          }
        });
      },
      {
        threshold: 0.25,
      }
    );
    observer.observe(this);
  }
  setCTAVisibility(flag) {
    this.ctaButton.forEach((item, index) => {
      if (!flag) {
        item.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
      } else {
        item.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
      }
    });
  }
}
customElements.define("sht-slideshow-cta", SHTSlideshowCTA);
/* Slideshow */
/* Carousel */
class SHTCarousel extends SHTCustomComponent {
  constructor() {
    super();

    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");
    this.pagination = this.$(".js-carousel-pagination-dots");
    this.pagination_items = this.pagination?.querySelectorAll(".js-carousel-pagination-dot");

    this.scrollbarThumb = this.$(".js-scrollbar-thumb");
    this.scrollbarTrack = this.$(".js-scrollbar-track");
    this.desktopThumbItemCount = parseInt(this.scrollbarTrack?.dataset.thumbDesk);
    this.mobileThumbItemCount = parseInt(this.scrollbarTrack?.dataset.thumbMobile);
    this.totalItems = parseInt(this.scrollbarTrack?.dataset.thumbTotal);

    this.init();
    this.bindEventHandlers();
  }
  init() {
    if (this.dataset.enable == "false") return;
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);
    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }
    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));
    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);

    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
    this.updateCarousel();
  }

  pauseAllVideo() {
    this.$$(".js-media-item-youtube").forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    this.$$(".js-media-item-vimeo").forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });

    this.$$(".js-media-item-video").forEach(video => video.pause());
  }

  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }

    this.updateScrollIndicator();
    this.updatePagination();
    this.pauseAllVideo();
  }

  updatePagination() {
    if (this.pagination) {
      let item = this.pagination.querySelector(`li[data-dot-index="${this.currentPage}"]`);
      if (item) {
        this.pagination_items.forEach(el => el.classList.remove("is-active"));
        item.classList.add("is-active");
      }
    }
  }

  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
    } else {
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  isItemVisible(element, offset = 0) {
    if (typeof element == "undefined") return false;
    const lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset;

    return Math.floor(element.getBoundingClientRect().width + element.offsetLeft) <= Math.round(lastVisibleItem) && element.offsetLeft >= this.container.scrollLeft;
  }
  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 459px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollLeft == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.updateScrollIndicator();
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );

  }

  updateScrollIndicator () {
    if (!this.scrollbarTrack) return;

    this.widthThumDesk = this.desktopThumbItemCount * 100 / this.totalItems;
    this.widthThumMobile = this.mobileThumbItemCount * 100 / this.totalItems;

    this.maxScroll = this.container.scrollWidth - this.container.clientWidth;
    this.scrollPersent = (this.container.scrollLeft / this.maxScroll) * 100;

    this.thumbPersentDesk = this.calculateThumbPersent(this.desktopThumbItemCount);
    this.thumbPersentMobile = this.calculateThumbPersent(this.mobileThumbItemCount);

    this.scrollbarTrack.style.setProperty('--width-thumb-desktop', `${ this.thumbPersentDesk }%`);
    this.scrollbarTrack.style.setProperty('--width-thumb-mobile', `${ this.thumbPersentMobile }%`);
  }

  calculateThumbPersent(dataThumb) {
    return (dataThumb + this.scrollPersent / 100 * (this.totalItems - dataThumb)) * 100 / this.totalItems;
  }

  bindEventHandlers() {
    if (this.dataset.enable == "false") return;
    const resizeObserver = new ResizeObserver(entries => this.init());
    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
  }
}
customElements.define("sht-carousel", SHTCarousel);
/* Carousel */
/* Color Swatch*/
class SHTColorSwatch extends SHTCustomComponent {
  constructor() {
    super();
    this.json = null;
    this.jsonDataElement = SHTHelper.qs(`#colorSwatchData[type="application/json"]`) || null;

    this.variantSwatchItems = this.$$(".js-variant-swatch-item") || [];
    if (this.jsonDataElement && this.variantSwatchItems.length) {
      this.bindEventHandlers();
    }
  }

  onObserverHandler() {
    let observe = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.init();
          observer.unobserve(this);
        }
      });
    });
    observe.observe(this);
  }

  init() {
    this.json = JSON.parse(this.jsonDataElement.textContent);
    this.processJsonData();

    for (let i = 0, n = this.variantSwatchItems.length; i < n; i++) {
      let e = this.variantSwatchItems[i];
      let jsonData = this.json[`${e.dataset.optionValue}`];
      let classSwatchType = "";
      if (e.dataset.swatchSource !== "variant_image") {
        const optionValue = e.dataset.optionValue;
        const swatchOptionValue = e.dataset.swatchOptionValue;

        const applyStyles = (type, color = "", image = "") => {
          classSwatchType = type;
          e.style.backgroundColor = color;
          e.style.backgroundImage = image ? `url("${image}")` : "";
          e.style.backgroundSize = image ? "cover" : "";
          e.style.backgroundRepeat = image ? "no-repeat" : "";
        };

        if (jsonData !== undefined) {
          const isHexColor = SHTHelper.isHexColor(jsonData);
          const isImage = SHTHelper.isImage(jsonData);

          if (isImage) {
            applyStyles("image", "", jsonData);
          } else if (isHexColor) {
            applyStyles("color", jsonData);
          }
        } else if (SHTHelper.isColor(optionValue)) {
          applyStyles("color", optionValue);
        }

        if (swatchOptionValue) {
          const swatchHexColor = SHTHelper.isHexColor(swatchOptionValue);
          const swatchImage = SHTHelper.isImage(swatchOptionValue);

          if (swatchImage) {
            applyStyles("image", "", swatchOptionValue);
          } else if (swatchHexColor) {
            applyStyles("color", swatchOptionValue);
          }
        }

        if (e.style.backgroundImage || e.style.backgroundColor) {
          if (classSwatchType) e.classList.add(`clr-swh__type--${classSwatchType}`);
          e.classList.add("clr-swh__has-value");
        } else {
          e.querySelector(".js-variant-option-label")?.classList.remove("opacity-0");
        }
      }
    }
    // this.variantSwatchItems.forEach(e => {});
  }

  processJsonData() {
    if (this.json) {
      this.json = Object.assign.apply(
        {},
        this.json.color_swatch_name.map((v, i) => ({
          [v]: this.json.color_swatch_value[i],
        }))
      );
    }
  }

  bindEventHandlers() {
    this.onObserverHandler();
  }
}

class SHTVariantSwatch extends SHTColorSwatch {
  bindEventHandlers() {
    this.onObserverHandler();
    this.variantSwatchItems.forEach(e => {
      e.addEventListener("click", subEvent => {
        this.changeVariantImage(subEvent.currentTarget);
      });
    });
  }

  changeVariantImage(ele) {
    let mainImage = SHTHelper.qs(`#${ele.dataset.productImageId}`);
    let mainImageParent = mainImage.parentNode;
    mainImageParent.classList.add("is-loading");

    let mainImageLink = SHTHelper.qsa(`.${ele.dataset.productLinkClass}`);
    let variantImageTemplate = ele.querySelector("template");

    if (mainImage && variantImageTemplate) {
      this.setButtonVisibility(false);
      let variantImage = variantImageTemplate.content.firstElementChild.cloneNode(true);
      if (mainImage.src) {
        mainImage.src = variantImage.src;
      }

      if (mainImage.srcset) {
        if (variantImageTemplate.srcset) {
          mainImage.srcset = variantImage.srcset;
        } else {
          mainImage.srcset = variantImage.src;
        }
      }

      if (mainImageLink) {
        mainImageLink.forEach(e => {
          e.href = variantImage.getAttribute("data_url");
        });
      }
      ele.setAttribute("aria-current", "true");
      ele.classList.add("btn-active");
      ele.focus();
      mainImage.onload = e => {
        mainImageParent.classList.remove("is-loading");
      };
      mainImage.onerror = e => {
        mainImageParent.classList.remove("is-loading");
      };
    }
  }

  setButtonVisibility(flag) {
    if (this.variantSwatchItems) {
      this.variantSwatchItems.forEach(e => {
        if (flag) {
          e.setAttribute("aria-current", "true");
          e.classList.add("btn-active");
        } else {
          e.removeAttribute("aria-current");
          e.classList.remove("btn-active");
        }
      });
    }
  }
}
customElements.define("sht-variant-swtch", SHTVariantSwatch);

class SHTMainProductVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-prd-variant-swtch", SHTMainProductVariantSwatch);

class SHTMainCollectionProductVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-coll-prd-variant-swtch", SHTMainCollectionProductVariantSwatch);

class SHTMainProductVariantSwatchWSelect extends SHTColorSwatch {}

customElements.define("sht-prd-variant-swtch-w-select", SHTMainProductVariantSwatchWSelect);

class SHTProductQuickViewVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-prd-qck-vw-variant-swtch", SHTProductQuickViewVariantSwatch);

class SHTFeaturedProductVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-featured-prd-variant-swtch", SHTFeaturedProductVariantSwatch);

class SHTProductComparisonVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-prd-comparison-variant-swtch", SHTProductComparisonVariantSwatch);

class SHTMainSearchVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-srch-variant-swtch", SHTMainSearchVariantSwatch);
/* Color Swatch*/

/* Load Media */
class SHTLoadMedia extends SHTCustomComponent {
  constructor() {
    super();
    this.trigger = this.$(".js-load-media-trigger");
    this.trigger.addEventListener("click", evt => {
      evt.preventDefault();
      this.loadMedia(false);
    });
  }

  loadMedia(focus = true, hide_trigger = true) {
    this.pauseAllVideo();
    if (!this.getAttribute("loaded")) {
      let content = document.createElement("div");
      content.appendChild(this.$("template").content.firstElementChild.cloneNode(true));
      this.setAttribute("loaded", true);
      const mediaElement = this.appendChild(content.querySelector("video, iframe"));
      if (focus) mediaElement.focus();
      if (hide_trigger) this.trigger.classList.add("hidden-trigger");
    }
  }

  pauseAllVideo() {
    SHTHelper.qsa(".js-media-item-youtube").forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    SHTHelper.qsa(".js-media-item-vimeo").forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });

    SHTHelper.qsa(".js-media-item-video").forEach(video => video.pause());
  }
}

customElements.define("sht-load-media", SHTLoadMedia);
/* Load Media */

/* localization */
var VAR_LOCALIZATION_CACHE = new Map();
class SHTLocalization extends SHTCustomComponent {
  constructor() {
    super();
    if (Shopify.designMode) {
      this.getSearchResults();
    } else {
      const handleIntersection = async (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        await this.getSearchResults();
        observer.unobserve(this);
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        threshold: 0.25,
      }).observe(this);
    }
  }

  async getSearchResults() {
    SHTHelper.loadScript(
      this.dataset.jsFileId,
      this.dataset.jsFile,
      async function () {
        let key = this.dataset.url.replace(/\s/g, "-").toLowerCase();

        let cached = VAR_LOCALIZATION_CACHE.get(key);

        if (!cached) {
          let markup = await this.fetchResults();
          VAR_LOCALIZATION_CACHE.set(key, markup);
          this.innerHTML = markup;
        } else {
          this.innerHTML = cached;
        }
      }.bind(this)
    );
  }

  async fetchResults() {
    let results = fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const languages = html.querySelector(`#${this.dataset.sectionId}`);
        if (languages && languages.innerHTML.trim().length) {
          return languages.innerHTML;
        }
        return "";
      })
      .catch(e => {
        console.error(e);
        return "";
      });

    return results;
  }
}

customElements.define("sht-localization", SHTLocalization);
/*localization */
/*Collapsible*/
class SHTCollapsibleRegion extends SHTCustomComponent {
  constructor() {
    super();
    this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {};

    this.triggers = this.$$(".js-collapsible-region-trigger");
    this.contents = this.$$(".js-collapsible-region-content");

    this.bodyWidth = document.body.clientWidth;

    this.isCollapsibleOnDesktop = this.properties.isCollapsibleOnDesktop;
    this.isCollapsibleOnMobile = this.properties.isCollapsibleOnMobile;

    this.init();
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if (!this.isCollapsibleOnDesktop || !this.isCollapsibleOnMobile) {
      window.addEventListener("resize", e => {
        this.bodyWidth = Math.floor(document.body.clientWidth);
        this.init();
      });
    }
    this.triggers.forEach(ele => {
      ele.addEventListener("click", e => {
        this.onTriggerClick(e.currentTarget);
      });
    });
  }

  init() {
    if ((!this.isCollapsibleOnDesktop && this.bodyWidth > 769) || (!this.isCollapsibleOnMobile && this.bodyWidth <= 769)) {
      this.removeAriaProps();
    }

    if ((this.isCollapsibleOnDesktop && this.bodyWidth > 769) || (this.isCollapsibleOnMobile && this.bodyWidth <= 769)) {
      this.restoreAriaProps();
    }
  }

  removeAriaProps() {
    this.triggers.forEach(ele => {
      ele.style.pointerEvents = "none";
      ele.setAttribute("tabindex", -1);
      ele.removeAttribute("aria-controls");
      ele.removeAttribute("aria-expanded");
    });

    this.contents.forEach(ele => {
      ele.removeAttribute("aria-describedby");
      ele.removeAttribute("role");
      ele.removeAttribute("hidden");
    });
  }

  restoreAriaProps() {
    this.triggers.forEach(ele => {
      ele.style.pointerEvents = "auto";
      ele.setAttribute("aria-controls", this.properties.ariaControls);
      ele.setAttribute("aria-expanded", "false");
      ele.removeAttribute("tabindex");
    });

    this.contents.forEach(ele => {
      ele.setAttribute("aria-describedby", this.properties.ariaDescribedby);
      ele.setAttribute("role", "region");
      ele.setAttribute("hidden", "");
    });
  }
  onTriggerClick(e) {
    let open = e.getAttribute("aria-expanded") === "true";

    this.toggle(!open, e);
  }

  toggle(open, e) {
    e.setAttribute("aria-expanded", `${open}`);
    let content = this.$(`#${e.getAttribute("aria-controls")}`);

    if (open) {
      e.classList.add("open");
      content.removeAttribute("hidden");
    } else {
      e.classList.remove("open");
      content.setAttribute("hidden", "");
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}
customElements.define("sht-clps-rgn", SHTCollapsibleRegion);
/*Collapsible*/
/* Dialog */
class SHTDialogCore extends SHTCustomComponent {
  constructor() {
    super();
    this.dialog = this.$(".dialog");
    this.closeBtn = this.$$(".js-dialog-close-btn");
    this.body = this.$(".js-dialog-body");
    this.container = this.$(".js-dialog-container");
    this.closeModalOnOverlayClick = this.dataset.closeModalOnOverlay || "true";

    this.opener = null;
    this.bodyElement = document.body;
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.closeBtn.forEach(btn => {
      btn.addEventListener("click", event => {
        this.closeModal();
      });
    });

    this.addEventListener("click", event => {
      if (event.target.nodeName === this.tagName && this.closeModalOnOverlayClick === "true") this.closeModal();
    });

    this.addEventListener("keyup", evt => evt.code.toUpperCase() === "ESCAPE" && this.closeModal());
    this.dialogAttrObserve();
  }

  dialogAttrObserve() {
    let dialogAttrObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach(async mutation => {
        if (mutation.attributeName == "hidden") {
          const isOpen = !this.hasAttribute("hidden");
          if (isOpen) {
            // if (this.container) {
            //   this.container.style.maxHeight = `${this.scrollHeight}px`;
            // }
            this.dispatchEvent(
              new CustomEvent("opening", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );

            await this.animationsComplete();
            this.dispatchEvent(
              new CustomEvent("opened", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            SHTHelper.trapFocus(this);
            // this.bodyElement.classList.add("o-hidden");
          } else {
            // if (this.container) {
            //   this.container.style.maxHeight = `0px`;
            // }
            SHTHelper.removeTrapFocus(this.opener);
            this.dispatchEvent(
              new CustomEvent("closing", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            await this.animationsComplete();
            this.dispatchEvent(
              new CustomEvent("closed", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            // this.bodyElement.classList.remove("o-hidden");
          }
        }
      });
    });

    dialogAttrObserver.observe(this, {
      attributes: true,
    });
  }

  animationsComplete() {
    return Promise.allSettled(this.dialog.getAnimations({ subtree: true }).map(animation => animation.finished));
  }

  processBodyContent() {
    this.template = this.$("template");

    if (!this.template) return;
    let content = this.template.content;
    this.body.appendChild(content);
  }

  showModal(opener, template = false) {
    SHTHelper.preventStickyHeaderReveal();

    if (template) {
      this.processBodyContent();
    }
    this.opener = opener;
    this.toggleAttribute("hidden", false);
    this.classList.add("is-active");
  }

  closeModal() {
    this.setAttribute("hidden", true);
    this.classList.remove("is-active");
  }
}

class SHTDialogQuickShop extends SHTDialogCore {
  constructor() {
    super();
  }

  showModal(opener) {
    SHTHelper.preventStickyHeaderReveal();
    this.opener = opener;
    this.opener?.setAttribute("disabled", "disabled");
    this.processData(opener);
    document.body.classList.add("o-hidden");
  }

  processData(opener) {
    this.productElement = null;
    fetch(opener.getAttribute("data-product-url"))
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        this.productElement = responseHTML.querySelector(".section-product-quick-view");

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        this.body.innerHTML = this.productElement.innerHTML;
        this.executeScriptElements(this.body);
        if (window.SHTProductMediaItemModel) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
      })
      .finally(() => {
        this.toggleAttribute("hidden", false);
        this.classList.add("is-active");

        this.opener?.removeAttribute("disabled");
      });
  }

  closeModal() {
    this.setAttribute("hidden", true);
    this.classList.remove("is-active");
    document.body.classList.remove("o-hidden");

    setTimeout(() => {
      this.body.innerHTML = "";
    }, 300);
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");

    Array.from(scriptElements).forEach(scriptElement => {
      const clonedElement = document.createElement("script");

      Array.from(scriptElement.attributes).forEach(attribute => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });

      clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }
}
customElements.define("sht-dialog-quickshop", SHTDialogQuickShop);

class SHTDialog extends SHTDialogCore {
  constructor() {
    super();
  }
}
customElements.define("sht-dialog", SHTDialog);

class SHTProductSpecificationDialog extends SHTDialogCore {}
customElements.define("sht-product-specification-dialog", SHTProductSpecificationDialog);
/* Dialog */
/* Form Input*/
class SHTQuantityInput extends SHTCustomComponent {
  constructor() {
    super();
    this.input = this.$(`.js-quantity-input`);
    this.changeEvent = new Event("change", { bubbles: true });
    this.$$(".js-quantity-btn").forEach(button => button.addEventListener("click", this.onButtonClickHandler.bind(this)));
  }

  onButtonClickHandler(event) {
    event.preventDefault();
    let previousValue = this.input.value;
    event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}
customElements.define("sht-qty-inp", SHTQuantityInput);
/* Form Input*/
/* Drawer */
class SHTCoreDrawer extends SHTCustomComponent {
  constructor() {
    super();
    this.drawerWrapperElement = this.$(".js-drawer-wrapper");
    this.drawerOverlayElement = this.$(".js-drawer-overlay");
    this.closeBtnElement = this.$(".js-drawer-btn-close");
    this.opener = null;
    this.bodyElement = document.body;
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.drawerOverlayElement.addEventListener("click", this.closeDrawer.bind(this));

    this.closeBtnElement.addEventListener("click", this.closeDrawer.bind(this));
    window.addEventListener("load", () => {
      this.removeAttribute("hidden");
    });

    this.addEventListener("keyup", evt => evt.code.toUpperCase() === "ESCAPE" && this.closeDrawer());
    this.drawerAttrObserve();
  }

  drawerAttrObserve() {
    let drawerAttrObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach(async mutation => {
        if (mutation.attributeName == "open") {
          const isOpen = this.hasAttribute("open");
          if (isOpen) {
            this.opener?.removeAttribute("disabled");
            this.opener?.setAttribute("aria-expanded", "true");
            this.setAttribute("aria-hidden", "false");
            this.dispatchEvent(new Event("opening"));
            this.bodyElement.classList.add("o-hidden");
            this.classList.add("active");
            await this.animationsComplete();
            this.dispatchEvent(new Event("opened"));
            SHTHelper.trapFocus(this);
          } else {
            SHTHelper.removeTrapFocus(this.opener);
            this.setAttribute("aria-hidden", "true");
            this.opener?.setAttribute("aria-expanded", "false");
            this.opener?.removeAttribute("disabled");
            this.dispatchEvent(new Event("closing"));
            this.bodyElement.classList.remove("o-hidden");
            this.classList.remove("active");
            await this.animationsComplete();
            this.dispatchEvent(new Event("closed"));
          }
        }
      });
    });

    drawerAttrObserver.observe(this, {
      attributes: true,
    });
  }

  animationsComplete() {
    return Promise.allSettled(this.drawerWrapperElement.getAnimations().map(animation => animation.finished));
  }

  openDrawer(opener) {
    SHTHelper.preventStickyHeaderReveal();
    this.opener = opener;
    this.removeAttribute("hidden");
    this.toggleAttribute("open", true);
  }

  closeDrawer() {
    this.toggleAttribute("open", false);
  }
}

class SHTDrawer extends SHTCoreDrawer {}
customElements.define("sht-drwr", SHTDrawer);
/* Drawer */
/* Cart Drawer */
class SHTCartDrawer extends SHTCoreDrawer {
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        space_selector: `#cartDrawer`,
      },
    ];
  }
}
customElements.define("sht-cart-drwr", SHTCartDrawer);
/* Cart Drawer */
/* Cart Drawer Cart Note */
class SHTCartDrawerCartNote extends SHTCustomComponent {
  constructor() {
    super();
    this.addEventListener(
      "change",
      SHTHelper.debounce(event => {
        const body = JSON.stringify({
          note: event.target.value,
        });
        fetch(`${window.routes.cart_update_url}`, {
          ...SHTHelper.fetchConfigJSON,
          ...{
            body,
          },
        });
      }, 300)
    );
  }
}
customElements.define("sht-cart-drwr-note", SHTCartDrawerCartNote);
/* Cart Drawer Cart Note */
/* Cart Drawer Quantity Input */
class SHTCartDrawerQuantityInput extends SHTCustomComponent {
  constructor() {
    super();
    this.input = this.$(`.js-cart-drawer-quantity-input`);
    this.changeEvent = new Event("change", {
      bubbles: true,
    });
    this.button = this.$$(".js-cart-drawer-quantity-btn");
    for (let i = 0, n = this.button.length; i < n; i++) {
      this.button[i].addEventListener("click", this.onButtonClickHandler.bind(this));
    }
  }
  onButtonClickHandler(event) {
    event.preventDefault();

    let previousValue = this.input.value;
    event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}
customElements.define("sht-cart-drwr-qty-inp", SHTCartDrawerQuantityInput);
/* Cart Drawer Quantity Input */
/* Cart Drawer Remove Button */
class SHTCartDrawerRemoveButton extends SHTCustomComponent {
  constructor() {
    super();
    this.addEventListener("click", event => {
      event.preventDefault();
      this.closest("sht-cart-drwr-frm").updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("sht-cart-drwr-rmv-btn", SHTCartDrawerRemoveButton);
/* Cart Drawer Remove Button */

/* Text HotSpots */
class SHTTextHotSpot extends SHTCustomComponent {
  constructor() {
    super();
    this.btn = this.$$(".js-text-hotspot-button");
    this.content = this.$$(".js-text-hotspot-content");
    this.bindEventHandlers();
  }
  bindEventHandlers() {
    this.btn.forEach(el => {
      el.addEventListener("click", e => {
        this.resetActiveState();
        let id = e.currentTarget.getAttribute("aria-controls");
        e.currentTarget.classList.add("is-active");
        this.$(`.js-text-hotspot-content#${id}`)?.classList.add("is-active");
      });
    });

    this.content.forEach(el => {
      el.addEventListener("click", e => {
        this.resetActiveState();
        let id = e.currentTarget.getAttribute("id");
        e.currentTarget.classList.add("is-active");
        this.$(`.js-text-hotspot-button[aria-controls="${id}"]`)?.classList.add("is-active");
      });
    });
  }
  resetActiveState() {
    this.btn.forEach(el => el.classList.remove("is-active"));
    this.content.forEach(el => el.classList.remove("is-active"));
  }
}
customElements.define("sht-text-hotspots", SHTTextHotSpot);
/* Text HotSpots */

class SHTDetailsExposal extends SHTCustomComponent {
  constructor() {
    super();
    //this.$ = this.querySelector.bind(this);

    this.detailsElm = this.$("details");
    this.content = this.detailsElm.querySelector("summary").nextElementSibling;

    this.detailsElm.addEventListener("focusout", this.onFocusOutHandler.bind(this));
    this.detailsElm.addEventListener("toggle", this.onToggleHandler.bind(this));
  }

  onFocusOutHandler() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggleHandler() {
    if (this.detailsElm.hasAttribute("open")) {
      this.detailsElm.querySelector("summary").setAttribute("aria-expanded", true);
    } else {
      this.detailsElm.querySelector("summary").setAttribute("aria-expanded", false);
    }
  }

  close() {
    this.detailsElm.removeAttribute("open");
    this.detailsElm.querySelector("summary").setAttribute("aria-expanded", false);
  }
}

customElements.define("sht-dtl-exposal", SHTDetailsExposal);

class SHTShareProductButton extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.webShareApiContainer = this.$(`.js-web-share-api-container`);
    this.webShareApiButton = this.$(`.js-web-share-api-btn`);

    this.noneWebShareApiContainer = this.$(`.js-none-web-share-api-container`);
    this.noneWebShareApiButton = this.$(`.js-none-web-share-api-btn`);

    this.copyLinkButton = this.$(`.js-social-share-copy-link`);
    this.init();
  }

  init() {
    if (navigator.share) {
      this.webShareApiContainer.removeAttribute("hidden");
      this.noneWebShareApiContainer.setAttribute("hidden", true);
      this.webShareApiButton.addEventListener("click", () => {
        navigator
          .share({
            url: this.dataset.productUrl,
            title: document.title,
          })
          .then(() => {
            console.log("Thanks for sharing!");
          })
          .catch(console.error);
      });
    } else {
      this.noneWebShareApiContainer.removeAttribute("hidden");
      this.webShareApiContainer.setAttribute("hidden", true);
      this.copyLinkButton.addEventListener("click", e => {
        this.copyToClipboard(e.currentTarget);
      });
    }
  }

  copyToClipboard(e) {
    navigator.clipboard.writeText(this.dataset.productUrl).then(() => {
      e.querySelector(".js-social-share-copy-link-label").textContent = e.dataset.linkCopiedToClipboard;
    });
  }
}
customElements.define("sht-share-prd-btn", SHTShareProductButton);
/* Header */
class SHTHeader extends SHTCustomComponent {
  constructor() {
    super();
    this.searchHeaderOpenBtn = this.$(".js-search-open-trigger");
    this.predictiveSearchElm = this.$(".js-predictive-search");
    this.predictiveSearchInputElm = this.$(".js-predictive-search-input");
    this.headerNavigation = this.$(".js-header-navigation");
    this.bodyElement = document.body;
    this.toggleNavItemBtn = this.$$(".js-toggle-nav-item");

    this.bindEventHandlers();
    this.dataset.showSearchFull == "false";
  }

  bindEventHandlers() {
    this.searchHeaderOpenBtn.addEventListener("click", this.openPredictiveSearch.bind(this));
  }

  openPredictiveSearch(e) {
    // SHTHelper.loadScript(
    //   e.currentTarget.dataset.jsFileId,
    //   e.currentTarget.dataset.jsFile,
    //   function () {
    //     this.classList.add("header--predictive-search-open");

    //     setTimeout(() => {
    //       SHTHelper.trapFocus(
    //         this.predictiveSearchElm,
    //         this.predictiveSearchInputElm
    //       );
    //     }, 650);
    //   }.bind(this)
    // );
    this.classList.add("header--predictive-search-open");
    this.bodyElement.classList.add("o-hidden");

    setTimeout(() => {
      SHTHelper.trapFocus(this.predictiveSearchElm, this.predictiveSearchInputElm);
    }, 650);
  }

  // loadScript() {
  //   const handleIntersection = async (entries, observer) => {
  //     if (!entries[0].isIntersecting) return;
  //     SHTHelper.loadScript(
  //       this.dataset.jsFileId,
  //       this.dataset.jsFile,
  //       function () {
  //         observer.unobserve(this);
  //       }.bind(this)
  //     );
  //   };
  //   new IntersectionObserver(handleIntersection.bind(this), {
  //     threshold: 0.25,
  //   }).observe(this);
  // }
}

customElements.define("sht-header", SHTHeader);
/* Header */

/* SHT Menu Header */
class SHTMenuHeader extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.header = SHTHelper.qs(`sht-header`);
    this.details = this.$("details");
    this.summaries = this.$$("summary");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;
    this.content_animations = null;
    this.menu_body_drawer = SHTHelper.qs(`.js-menu-drawer-body-container`);
    //this.details.addEventListener("focusout", this.onFocusOutEvent.bind(this));

    this.level_one_btn = this.$$(`.js-menu-header-back-btn[data-level="1"]`);
    this.level_two_btn = this.$$(`.js-menu-header-back-btn[data-level="2"]`);

    for (let i = 0, n = this.summaries.length; i < n; i++) {
      let summary = this.summaries[i];
      summary.addEventListener("click", event => {
        event.preventDefault();
        let details = event.currentTarget.closest("details");
        event.currentTarget.setAttribute("aria-expanded", !details.open);
        if (!details.hasAttribute("open")) {
          this.open();
          details.open = true;
          // details.classList.toggle("is-open", !details.open);
          setTimeout(() => {
            details.classList.add("is-open");
          });
          if (details.dataset.level == "1") {
            this.header.classList.add("header-menu--open");
            this.menu_body_drawer?.classList.add("menu--is-open");
          }
        } else {
          details.classList.remove("is-open");
          setTimeout(() => {
            details.open = false;
          }, 100);
          if (details.dataset.level == "1") {
            this.header.classList.remove("header-menu--open");
            this.menu_body_drawer?.classList.remove("menu--is-open");
          }
        }
      });
      summary.addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
    }
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.level_one_btn.forEach(e => {
      e.addEventListener("click", el => {
        let details = el.currentTarget.closest("details");
        let summary = details.querySelector("summary:first-child");
        summary.setAttribute("aria-expanded", !details.open);
        if (details.hasAttribute("open")) {
          details.classList.toggle("is-open", !details.open);
          setTimeout(() => {
            details.open = false;
          }, 100);
          if (details.dataset.level == "1") {
            this.header.classList.remove("header-menu--open");
            this.menu_body_drawer?.classList.remove("menu--is-open");
          }
          summary.focus();
        }
      });
    });

    this.level_two_btn.forEach(e => {
      e.addEventListener("click", el => {
        let details = el.currentTarget.closest("details");
        let summary = details.querySelector("summary:first-child");
        summary.setAttribute("aria-expanded", !details.open);

        if (details.hasAttribute("open")) {
          details.classList.toggle("is-open", !details.open);
          setTimeout(() => {
            details.open = false;
          }, 100);
          if (details.dataset.level == "1") {
            this.header.classList.remove("header-menu--open");
            this.menu_body_drawer?.classList.remove("menu--is-open");
          }

          summary.focus();
        }
      });
    });
  }
  onKeyUpEscEvent(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    let openedDetails = event.target.closest("details[open]");
    if (!openedDetails) return;

    document.body.removeEventListener("click", this.onBodyClick);
    let summary = openedDetails.querySelector("summary");
    if (openedDetails.dataset.level == "1") {
      if (!openedDetails.hasAttribute("open")) {
        this.header.classList.add("header-menu--open");
        this.menu_body_drawer?.classList.add("menu--is-open");
      } else {
        this.header.classList.remove("header-menu--open");
        this.menu_body_drawer?.classList.remove("menu--is-open");
      }
    }
    openedDetails.classList.remove("is-open");
    this.menu_body_drawer?.classList.remove("menu--is-open");
    setTimeout(() => {
      openedDetails.removeAttribute("open");
      summary.setAttribute("aria-expanded", false);
    }, 100);
    summary.focus();
  }

  /*onFocusOutEvent(e) {
    setTimeout(() => {
      if (
        !this.contains(e.relatedTarget) &&
        e.relatedTarget != null &&
        e?.relatedTarget?.tagName != "SHT-MENU-DRWER"
      )
        this.close();
    });
  }*/

  close() {
    if (this.details.dataset.level == "1") {
      if (this.details.hasAttribute("open")) {
        this.header.classList.remove("header-menu--open");
        this.menu_body_drawer?.classList.remove("menu--is-open");
      }
    }

    for (let i = 0, n = this.summaries.length; i < n; i++) {
      let summary = this.summaries[i];
      let details = summary.closest("details");
      details.classList.remove("is-open");
      setTimeout(() => {
        details.removeAttribute("open");
        summary.setAttribute("aria-expanded", false);
      }, 100);
    }

    document.body.removeEventListener("click", this.onBodyClick);
  }

  open() {
    document.body.addEventListener("click", this.onBodyClick);
  }

  handleBodyClick(evt) {
    let target = evt.target;

    setTimeout(() => {
      if (!this.contains(target)) this.close();
    });
  }
}
customElements.define("sht-menu-header", SHTMenuHeader);
/* SHT Menu Header */

/* Sticky Header  */
class SHTStickyHeader extends SHTCustomComponent {
  constructor() {
    super();
    this.sticky_state = this.dataset.stickyState;
  }
  /**
   * When the element is added to the DOM, the connectedCallback method is triggered
   */
  connectedCallback() {
    // this.is_enabled = this.dataset.isEnabled;
    //this.announcement_bar = SHTHelper.qs("sht-ann-bar") || null;
    this.prevent_reveal = false;
    this.css_ary = ["top-0", "zi-4", "header--sticky", "is-header-hide"];
    this.header = SHTHelper.qs(".js-section-header");
    this.sht_header = SHTHelper.qs("sht-header");
    this.currentScrollTop = 0;
    this.headerBounds = {};
    this.product_sticky_bar = SHTHelper.qs(".js-product-sticky-bar");
    this.bindEventHandlers();
    if (this.sticky_state == "false") return false;

    this.createObserver();
  }

  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    if (this.sticky_state == "false") return false;

    this.preventStickyHeaderReveal = () => (this.prevent_reveal = true);
    this.addEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal);

    window.addEventListener(
      "scroll",
      e => {
        this.onScrollHandle();
        SHTHelper.qde.style.setProperty("--header-height", `${this.sht_header.offsetHeight}px`);
      },
      false
    );
  }
  /**
   * monitor the header element
   */
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.header_bounds = entries[0].intersectionRect;

      observer.disconnect();
    });

    observer.observe(this.header);
  }
  /**
   * Handle on scroll event
   */
  onScrollHandle() {
    if (!this.header_bounds) return;

    let scrollTop = window.pageYOffset || SHTHelper.qde.scrollTop;

    if (this.sticky_state == "always_reveal") {
      requestAnimationFrame(() => {
        this.product_sticky_bar?.classList.add("header-reveal" , "product-sticky-bar--sticky");
      });
      if (scrollTop > this.parentNode.offsetTop - 1 && scrollTop > 0) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        requestAnimationFrame(this.reset.bind(this));
      }
      return;
    }

    if (this.getBoundingClientRect().bottom < 0) {
      this.header.classList.add("header--sticky", "is-header-sticky");
      requestAnimationFrame(() => {
          this.product_sticky_bar?.classList.add("header-reveal");
        });
    } else {
      this.header.classList.remove("header--sticky", "is-header-sticky");
      requestAnimationFrame(() => {
        this.product_sticky_bar?.classList.remove("header-reveal");
      });
    }
    if (scrollTop < this.currentScrollTop && this.getBoundingClientRect().bottom < 0) {
      this.header.classList.add("is-header-show");
      requestAnimationFrame(() => {
        this.product_sticky_bar?.classList.add("header-reveal");
      });
    } else {
      this.header.classList.remove("is-header-show");
      requestAnimationFrame(() => {
        this.product_sticky_bar?.classList.remove("header-reveal");
      });
      this.closeMenu();
    }

    // if (scrollTop > this.currentScrollTop && scrollTop > this.header_bounds.bottom) {
    //   if (this.prevent_reveal) {
    //     window.clearTimeout(this.is_scrolling);
    //     this.is_scrolling = setTimeout(() => {
    //       this.prevent_reveal = false;
    //     }, 20);
    //     return;
    //   }

    //   requestAnimationFrame(this.hide.bind(this));
    //   requestAnimationFrame(() => {
    //     this.product_sticky_bar?.classList.remove("header-reveal");
    //   });
    // } else if (scrollTop < this.currentScrollTop && scrollTop > this.header_bounds.bottom) {
    //   if (this.prevent_reveal) {
    //     requestAnimationFrame(this.hide.bind(this));
    //     window.clearTimeout(this.is_scrolling);
    //     this.is_scrolling = setTimeout(() => {
    //       this.prevent_reveal = false;
    //     }, 20);
    //     return;
    //   }

    //   requestAnimationFrame(this.reveal.bind(this));
    //   requestAnimationFrame(() => {
    //     this.product_sticky_bar?.classList.add("header-reveal");
    //   });
    // } else if (scrollTop <= this.header_bounds.top) {
    //   requestAnimationFrame(this.reset.bind(this));
    //   requestAnimationFrame(() => {
    //     this.product_sticky_bar?.classList.remove("header-reveal");
    //   });
    // } else {
    //   //do nothing
    // }

    this.currentScrollTop = scrollTop;
  }
  hide() {
    // this.header.classList.add(...this.css_ary);
    // this.header.classList.remove("animate");
    this.header.classList.add("is-header-hide", "p-sticky", "top-0", "zi-4", "header--sticky");

    this.closeMenu();
  }
  reveal() {
    this.header.classList.add("top-0", "animate", "zi-4", "p-sticky", "header--sticky");
    this.header.classList.remove("is-header-show");
  }
  reset() {
    this.header.classList.remove("is-header-show", "top-0", "animate", "header--sticky", "p-sticky");
  }

  closeMenu() {
    this.menus = this.header.querySelectorAll("sht-menu-header");

    for (let i = 0, n = this.menus.length; i < n; i++) {
      this.menus[i].close();
    }
  }
  /**
   * When the element is removed from the DOM, the disconnectedCallback method is triggered
   */
  disconnectedCallback() {
    this.removeEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal);
    window.removeEventListener("scroll", this.onScrollHandle.bind(this));
  }
}
customElements.define("sht-sticky-header", SHTStickyHeader);
/* Sticky Header  */

/* Cart Notification */
class SHTCartNotificationPanel extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    // this.$$ = this.querySelectorAll.bind(this);
    this.elms = {
      notification_wrapper: this.$(`.js-cart-notification-panel-wrapper`),
      notification_container: this.$(`.js-cart-notification-panel-container`),
      close_buttons: this.$$(".js-cart-notification-panel-close-btn"),
    };
    this.dismiss_timeout = null;

    for (let i = 0, n = this.elms.close_buttons.length; i < n; i++) {
      this.elms.close_buttons[i].addEventListener("click", this.close.bind(this));
    }
  }

  /**
   * bind event handler to web component elements
   */

  open() {
    this.style.maxHeight = `${this.scrollHeight}px`;
    this.togglePanel(true);
    this.elms.notification_container.focus();
    this.addEventListener("mouseover", this.onMouseOverHandle.bind(this));
    this.addEventListener("mouseout", this.onMouseOutHandle.bind(this));
    this.setDismissTimeout();
    SHTHelper.trapFocus(this);
  }

  close() {
    this.style.maxHeight = `0px`;
    this.clearDismissTimeout();
    this.togglePanel(false);
    this.dispatchEvent(new Event("closed"));
    SHTHelper.removeTrapFocus();
  }

  clearDismissTimeout() {
    clearTimeout(this.dismiss_timeout);
  }

  renderContents(response) {
    this.productId = response.id;
    let sections = this.getSectionsToRender();
    for (let i = 0, n = sections.length; i < n; i++) {
      let element = SHTHelper.qs(sections[i].space_selector);
      if (element) {
        if (sections[i].space_selector == "#headerCartStatus") {
          element.classList.add("header-cart-status--animate");
        }
        element.innerHTML = this.getSectionInnerHTML(response.sections[sections[i].id], sections[i].selector);
      }
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-panel-product",
        selector: `.js-cart-notification-panel-product-${this.productId}`,
        space_selector: `.js-cart-notification-panel-content`,
      },
      // {
      //   id: "free-shipping-notification",
      //   selector: `.js-free-shipping-notification`,
      //   space_selector: `.js-cart-notification-free-shipping`,
      // },
      {
        id: "header-cart-status",
        section: "header-cart-status",
        space_selector: `#headerCartStatus`,
      },
      {
        id: "cart-notification-panel-product",
        selector: `.js-cart-notification-panel-item-count`,
        space_selector: `.js-cart-notification-panel-item-count-content`,
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  onMouseOverHandle(evt) {
    this.clearDismissTimeout();
  }

  onMouseOutHandle(evt) {
    this.setDismissTimeout();
  }

  togglePanel(toggle) {
    if (toggle) {
      this.toggleAttribute("hidden", false);
    } else {
      this.setAttribute("hidden", true);
    }
    return;
  }

  setDismissTimeout() {
    this.dismiss_timeout = setTimeout(
      function () {
        this.close();
      }.bind(this),
      5000
    );
  }
}

customElements.define("sht-cart-noti", SHTCartNotificationPanel);
/* Cart Notification */

/* Cart Drawer Form */
class SHTCartDrawerForm extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    // this.$$ = this.querySelectorAll.bind(this);
    this.totalItems = Array.from(this.$$(".js-cart-drawer-quantity-input")).reduce((total, ele) => total + parseInt(ele.value), 0);
    this.drawerCartElement = SHTHelper.qs("sht-cart-drwr");
    this.wrapperElement = this.drawerCartElement.querySelector(".js-cart-drawer-wrapper");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.addEventListener(
      "change",
      SHTHelper.debounce(event => {
        this.onChange(event);
      }, 300)
    );
    document.addEventListener('cart:update', this.handleCartUpdate.bind(this));

  }

  handleCartUpdate(event) {
    if (this.isProcessingCartUpdate) return;

    this.isProcessingCartUpdate = true;

    let sections = this.getSectionsToRender();
    if (this.cartNotification) {
      sections = [...sections, ...this.cartNotification.getSectionsToRender()];
    }

    const delay = event?.detail?.source === 'discount' ? 300 : 0;

    setTimeout(() => {
      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(cart => {
        if (cart.item_count === 0) {
          let cartEmpty = SHTHelper.qs(".js-drawer-empty");
          let cartDrawer = SHTHelper.qs(".js-cart-drawer-wrapper");
          let cartCountNumber = SHTHelper.qs(".js-cart-count-number");
          cartDrawer.innerHTML = cartEmpty.innerHTML;
          cartCountNumber.innerHTML = 0;
        } else {
          fetch(`?sections=${sections.map(section => section.section).join(',')}`)
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.text();
            })
            .then(state => {
              const parsedState = JSON.parse(state);
              this.renderContentsDiscount({ sections: parsedState });
            })
            .catch(error => {
              console.error("Error fetching cart sections:", error);
            });
        }
      })
      .catch(error => {
        console.error("Error fetching cart:", error);
      })
      .finally(() => {
        setTimeout(() => {
          this.isProcessingCartUpdate = false;
        }, 500);
      });
    }, delay);
  }

  disconnectedCallback() {
    if (this.cartUpdateHandler) {
      document.removeEventListener('cart:update', this.cartUpdateHandler);
      window.cartUpdateListenerRegistered = false;
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.dataset.name);
  }

  renderContents(parsedState) {
    this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty");
    this.getSectionsToRender().forEach(section => {
      section.selectors?.forEach(e => {
        let tmpElement = SHTHelper.qid(section.id);

        if (tmpElement && parsedState.sections[section.section]) {
          let shouldBeReplacedElm = tmpElement.querySelector(e) || tmpElement;
          shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], e);
        }
      });
    });
  }
  renderContentsDiscount(parsedState) {
    this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty");
    this.getSectionsToRenderDiscount().forEach(section => {
      section.selectors?.forEach(e => {
        let tmpElement = SHTHelper.qid(section.id);
        if (tmpElement && parsedState.sections[section.section]) {
          let shouldBeReplacedElm = tmpElement.querySelector(e);
          shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], e);
        }
      });
    });
  }
  getSectionsToRenderDiscount() {
    return [
      {
        id: "cartDrawer",
        section: "cart-drawer",
        selectors: [".js-cart-items", ".js-discount-pills", ".js-cart-total", ".js-cart-level-discount-applications"],
      },
      {
        id: "mainCart",
        section: "main-cart",
        selectors: [".js-cart-items", ".js-discount-pills", ".js-cart-total", ".js-cart-level-discount-applications"],
      }
    ];
  }
  getSectionsToRender() {
    return [
      {
        id: "cartDrawer",
        section: "cart-drawer",
        selectors: [".js-cart-drawer-wrapper"],
      },
      {
        id: "mainCart",
        section: "main-cart",
        selectors: ["#mainCartContainer"],
      },
      // {
      //   id: "HeaderCartStatus",
      //   section: "header-cart-status",
      //   selectors: [".shopify-section"],
      // },
    ];
  }
  updateQuantity(line, quantity, name) {
    let sections = this.getSectionsToRender();
    let parsedState = {};
    if (this.cartNotification) {
      sections = [...sections, ...this.cartNotification.getSectionsToRender()];
    }

    let body = JSON.stringify({
      line,
      quantity,
      sections: sections.map(section => section.section),
      sections_url: window.location.pathname,
    });
    this.updateButtonState(true);
    fetch(`${window.routes.cart_change_url}`, {
      ...SHTHelper.fetchConfigJSON,
      ...{
        body,
      },
    })
      .then(response => {
        return response.text();
      })
      .then(state => {
        parsedState = JSON.parse(state);
        if (parsedState.errors) {
          setTimeout(() => {
            this.updateErrorRegions(line, parsedState.errors);
          }, 100);
        } else {
          this.closest(".js-cart-drawer-wrapper").classList.toggle("is-empty", parsedState.item_count === 0);

          this.getSectionsToRender().forEach(section => {
            section.selectors.forEach(e => {
              let tepItem = SHTHelper.qid(section.id);
              if (tepItem) {
                let shouldBeReplacedElm = tepItem.querySelector(e) || tepItem;

                shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], e);
              }
            });
          });
          //console.log(parsedState.item_count, this.totalItems);

          let lineItem = SHTHelper.qid(`cartDrawerItem-${line}`);

          if (lineItem) {
            let quantityBtn = lineItem.querySelector(`.js-cart-drawer-quantity-btn-${name}`);
            quantityBtn && quantityBtn.focus();
          }

          /* Update header status */
          if (this.cartNotification) {
            this.cartNotification.getSectionsToRender().forEach(section => {
              if (section.id == "header-cart-status") {
                SHTHelper.qs(section.space_selector).innerHTML = this.cartNotification.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }
            });
          }
          /* Update header status */
        }
      })
      .catch(e => {
        this.$(".js-cart-drawer-errors").textContent = SHTLanguage.cart.ERROR;
        console.log(e.message, e.stack);
      })
      .finally(() => {
        this.updateButtonState(false);
        // setTimeout(() => {
        //   this.updateErrorRegions(line, parsedState.item_count);
        // }, 100);
      });
  }

  updateErrorRegions(line, error) {
    //if (this.totalItems === itemCount) {

    let item_line = SHTHelper.qs(`#cart-drawer-line-item-error-${line}`);
    let item_input = this.$(`.js-cart-drawer-quantity-input[data-index="${line}"]`);
    item_line.querySelector(".js-cart-drawer-form-item-error-message").innerHTML = error;

    item_line.classList.remove("d-none-important");
    if (item_input) {
      item_input.value = item_input.dataset.cartQuantity;
    }
    // }

    //  this.totalItems = itemCount;
  }
  /*updateErrorRegions(line, itemCount) {
    if (this.totalItems === itemCount) {
      let item_line = SHTHelper.qs(`#cart-drawer-line-item-error-${line}`);
      item_line.querySelector(
        ".js-cart-drawer-form-item-error-message"
      ).innerHTML = SHTLanguage.cart.QUANTITY_ERROR.replace(
        "[quantity]",
        SHTHelper.qs(`#cartDrawerQuantityField-${line}`).value
      );

      item_line.classList.remove("d-none-important");
    }

    this.totalItems = itemCount;
  }*/
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  updateButtonState(disabled) {
    let btn = this.$$(".js-cart-drawer-btn");
    let btnSubmit = this.drawerCartElement.querySelector(".js-cart-drawer-submit-btn");
    if (disabled) {
      for (let i = 0, n = btn.length; i < n; i++) {
        btn[i].setAttribute("disabled", "disabled");
      }
      btnSubmit && btnSubmit.setAttribute("disabled", "disabled");
    } else {
      for (let i = 0, n = btn.length; i < n; i++) {
        btn[i].removeAttribute("disabled", "disabled");
      }
      btnSubmit && btnSubmit.removeAttribute("disabled");
    }
  }
}
customElements.define("sht-cart-drwr-frm", SHTCartDrawerForm);
/* Cart Drawer Form */

/* Dynamic checkout button */
class SHTLoadDynamicCheckoutButtonDynamicCheckoutButton extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    //this.$ = this.querySelector.bind(this);

    this.template = this.$("template");
    this.onLoadDynamicCheckoutButton = this.onHandleLoadDynamicCheckoutButton.bind(this);
    this.bindEventHandlers();
    this.isMouseenter = false;
    this.json = JSON.parse(SHTHelper.qs(`#shopify-features[type="application/json"]`).textContent);
    if (Shopify.designMode) {
      this.loadDynamicCheckoutButton();
    } else {
      window.addEventListener("scroll", this.onLoadDynamicCheckoutButton, false);

      window.addEventListener(
        "load",
        function (event) {
          let timeout = setTimeout(
            function () {
              if (!this.isMouseenter) {
                this.loadDynamicCheckoutButton();
                clearTimeout(timeout);
              }
              this.isMouseenter = true;
            }.bind(this),
            3000
          );
        }.bind(this)
      );

      [("mouseenter", "touchstart", "mouseover")].forEach(
        function (e) {
          SHTHelper.qs("body").addEventListener(e, this.onLoadDynamicCheckoutButton);
        }.bind(this)
      );
    }
  }

  onHandleLoadDynamicCheckoutButton(event) {
    if (!this.isMouseenter) {
      this.loadDynamicCheckoutButton();
    }
    event.currentTarget.removeEventListener(event.type, this.onLoadDynamicCheckoutButton);
    this.isMouseenter = true;
  }

  loadDynamicCheckoutButton() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio === 1 && !this.getAttribute("loaded")) {
            let tmp = this.template.content.firstElementChild.cloneNode(true);
            let script = document.createElement("script");
            script.src = this.json.smart_payment_buttons_url;
            script.setAttribute("data-source-attribute", "shopify.dynamic_checkout.product.init");
            this.parentNode.insertBefore(tmp, this.nextSibling);
            this.parentNode.insertBefore(script, this.nextSibling);
            this.setAttribute("loaded", true);
            observer.unobserve(this);
          }
        });
      },
      {
        root: null,
        rootMargin: "50px 0px",
        threshold: 0,
      }
    );
    observer.observe(this);
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {}
}
customElements.define("sht-load-dyn-co-btn", SHTLoadDynamicCheckoutButtonDynamicCheckoutButton);
/* Dynamic checkout button */

class SHTHorizontalCarousel extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    // this.$$ = this.querySelectorAll.bind(this);
    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");
    this.init();
    this.bindEventHandlers();
  }
  init() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);
    if (this.itemsToShow.length < 2) {
      this.horizontalTogglePagination(false);
      return;
    }
    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));

    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
    this.updateCarousel();
  }
  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.horizontalTogglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.horizontalTogglePagination(false);
    }
  }
  isItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset + 1;
    return element.offsetLeft + element.clientWidth <= lastVisibleItem && element.offsetLeft >= this.container.scrollLeft;
  }
  horizontalTogglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 769px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollLeft == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    const resizeObserver = new ResizeObserver(entries => this.init());
    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    if (this.prevBtnElement) {
      this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }
    if (this.nextBtnElement) {
      this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }
    this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
  }
}
customElements.define("sht-horiz-carousel", SHTHorizontalCarousel);

class SHTVerticalCarousel extends SHTCustomComponent {
  constructor() {
    super();

    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");

    this.slideshow = SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`);
    this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`);
    
    // Lưu viewport width để phát hiện thay đổi thật sự
    this.lastViewportWidth = window.innerWidth;
    
    this.transform();
    window.addEventListener("resize", e => {
      this.transform(e);
    });
    // this.init();
    // this.bindEventHandlers();
  }

  transform(e) {
    // Chỉ gọi setActiveMedia khi viewport width thực sự thay đổi
    // Tránh gọi khi chỉ scroll (mobile browser ẩn/hiện address bar)
    const currentViewportWidth = window.innerWidth;
    const viewportWidthChanged = this.lastViewportWidth !== currentViewportWidth;
    this.lastViewportWidth = currentViewportWidth;
    
    if (!window.matchMedia("(min-width: 769px)").matches) {
      setTimeout(() => {
        this.horizontalInit();
        this.horizontalBindEventHandlers();
        // Chỉ set active media khi width thay đổi, không phải khi scroll
        if (typeof e != "undefined" && viewportWidthChanged) {
          this.horizontalSetActiveMedia();
        }
      }, 200);
    } else {
      setTimeout(() => {
        this.init();
        this.bindEventHandlers();
        // Chỉ set active media khi width thay đổi, không phải khi scroll
        if (typeof e != "undefined" && viewportWidthChanged) {
          this.setActiveMedia();
        }
      }, 200);
    }
  }
  /* horizontal */
  horizontalInit() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);

    if (this.itemsToShow.length < 2) {
      this.horizontalTogglePagination(false);
      return;
    }
    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));

    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.horizontalUpdateCarousel();
  }
  horizontalUpdateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.horizontalIsItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.horizontalTogglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.horizontalTogglePagination(false);
    }
  }
  horizontalIsItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleItem && element.offsetLeft >= this.container.scrollLeft;
  }
  horizontalOnButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 769px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollLeft == 0 || this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  horizontalBindEventHandlers() {
    // const resizeObserver = new ResizeObserver((entries) =>
    //   this.horizontalInit()
    // );
    // resizeObserver.observe(this.container);

    // const handleIntersection = (entries, observer) => {
    //   if (!entries[0].isIntersecting) return;

    //   this.horizontalInit();
    //   observer.unobserve(this);
    // };
    // new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    if (this.prevBtnElement) {
      this.prevBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this));
    }
    if (this.nextBtnElement) {
      this.nextBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this));
    }
    this.container.addEventListener("scroll", SHTHelper.debounce(this.horizontalUpdateCarousel.bind(this), 100));
  }
  horizontalTogglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  horizontalSetActiveMedia() {
    let activeThumb = this.$("sht-vert-carousel-itm.is-active-item");
    // let slideshow = SHTHelper.qs(
    //   `sht-prd-slideshow[data-section="${this.dataset.section}"]`
    // );
    // let carousel = SHTHelper.qs(
    //   `sht-carousel[data-section-id="${this.dataset.section}"]`
    // );
    if (activeThumb) {
      this.container.scrollTo({
        left: activeThumb.offsetLeft,
        behavior: "auto",
      });

      let activeMedia = this.slideshow.$(`sht-carousel-itm[data-media-id="${activeThumb.dataset.mediaTargetId}"]`);

      this.carousel.querySelector(".js-carousel-items").scrollTo({
        left: activeMedia.offsetLeft,
        behavior: "auto",
      });
    }
  }
  /* horizontal */
  /* Vertical */
  init() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);
    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }

    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-top")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-bottom"));
    this.itemOffset = this.itemsToShow[1].offsetTop - this.itemsToShow[0].offsetTop;
    this.itemsPerPage = Math.floor((this.container.clientHeight - this.itemsToShow[0].offsetTop) / this.itemOffset);
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.updateCarousel();
  }
  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollTop / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollTop === 0) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }
  }
  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  isItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientHeight + this.container.scrollTop - offset;
    return element.offsetTop + element.clientHeight - 1 <= Math.ceil(lastVisibleItem) && element.offsetTop >= this.container.scrollTop;
  }

  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 769px)");

    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollTop == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollTop - gutter + step * this.itemOffset : this.container.scrollTop + gutter - step * this.itemOffset;

    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        top: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    // const resizeObserver = new ResizeObserver((entries) => {
    //   this.init();
    // });
    // resizeObserver.observe(this.container);

    // const handleIntersection = (entries, observer) => {
    //   if (!entries[0].isIntersecting) return;

    //   this.init();
    //   observer.unobserve(this);
    // };
    // new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
  }

  setActiveMedia() {
    let activeThumb = this.$("sht-vert-carousel-itm.is-active-item");
    // let slideshow = SHTHelper.qs(
    //   `sht-prd-slideshow[data-section="${this.dataset.section}"]`
    // );
    if (activeThumb) {
      this.container.scrollTo({
        top: activeThumb.offsetTop,
        behavior: "auto",
      });

      let activeMedia = this.slideshow.$(`sht-carousel-itm[data-media-id="${activeThumb.dataset.mediaTargetId}"]`);

      this.slideshow.$$(".js-product-slideshow-item").forEach(element => {
        element.classList.remove("d-block");
        this.slideshow.hide_variant == "true" && element.classList.add("d-none");
      });

      activeMedia.classList.add("d-block");
      this.slideshow.hide_variant == "true" && activeMedia.classList.remove("d-none");
    }
  }
}
customElements.define("sht-vert-carousel", SHTVerticalCarousel);

// class SHTThumbCarousel extends SHTCustomComponent {
//   constructor() {
//     super();
//   }

//   init() {
//     this.container = this.$(".js-thumb-carousel-container");
//     if (!window.matchMedia("(min-width: 769px)").matches) {
//       let newElement = document.createElement("sht-horiz-carousel");
//       while (this.container.firstChild) {
//         newElement.appendChild(this.container.firstChild);
//       }

//       // Replace the existing Element with the new one
//       this.container.parentNode.replaceChild(newElement, this.container);
//       // this.container.tagName = "sht-horiz-carousel";
//     } else {
//       //this.container.tagName = "sht-vert-carousel";
//       let newElement = document.createElement("sht-vert-carousel");
//       while (this.container.firstChild) {
//         newElement.appendChild(this.container.firstChild);
//       }

//       // Replace the existing Element with the new one
//       this.container.parentNode.replaceChild(newElement, this.container);
//     }
//   }

//   replaceTag(tag) {
//     let oldTag = this.$(".js-thumb-carousel-container");
//     let newTag = document.createElement(tag);
//     newTag.setAttribute("class", oldTag.getAttribute("class"));
//     newTag.setAttribute(
//       "data-section-id",
//       oldTag.getAttribute("data-section-id")
//     );

//     while (oldTag.firstChild) {
//       console.log(tag);
//       newTag.appendChild(oldTag.firstChild);
//     }
//     newTag.parentNode.replaceChild(newTag, oldTag);
//   }

//   bindEventHandlers() {
//     window.addEventListener("resize", (e) => {
//       this.init();
//     });
//   }

//   connectedCallback() {
//     this.init();
//     //this.bindEventHandlers();
//   }
// }

// customElements.define("sht-thumb-carousel", SHTThumbCarousel);

class SHTProductSlideShowItem extends SHTCustomComponent {
  constructor() {
    super();
    //this.$ = this.querySelector.bind(this);
    this.openGalleryButton = this.$(".js-product-media-open-gallery-btn");
    if (this.openGalleryButton) {
      this.openGalleryButton.addEventListener("click", e => {
        this.openDialogGallery(e);
      });
    }
    this.slideshow = this.closest("sht-prd-slideshow");
    this.parent = this.closest("sht-carousel-itm");

    this.prepare();
  }

  openDialogGallery(e) {
    let dialog = SHTHelper.qs(`#${e.currentTarget.dataset.galleryDialogId}`);
    if (dialog) {
      dialog.showModal(e.currentTarget, true);
      this.slideshow.pauseAllVideo();
    }
  }

  prepare() {
    if (!window.matchMedia("(max-width: 459px)").matches) {
      if (!this.parent.classList.contains("d-block")) {
        this.slideshow.hide_variant == "true" && this.parent.classList.add("d-none");
      }
    } else {
      this.slideshow.hide_variant == "true" && this.parent.classList.remove("d-none");
    }
    let resizeObserver = new ResizeObserver(entries => {
      if (!window.matchMedia("(max-width: 459px)").matches) {
        if (!this.parent.classList.contains("d-block")) {
          this.slideshow.hide_variant == "true" && this.parent.classList.add("d-none");
        }
      } else {
        this.slideshow.hide_variant == "true" && this.parent.classList.remove("d-none");
      }
    });
    resizeObserver.observe(document.body);
  }
}
customElements.define("sht-prd-slideshow-itm", SHTProductSlideShowItem);

class SHTProductSlideShow extends SHTCustomComponent {
  constructor() {
    super();

    this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`);
    this.thumb_carousel = SHTHelper.qs(`sht-vert-carousel[data-section="${this.dataset.section}"]`);
    this.$$(".js-slideshow-btn-thumb").forEach((e, i) => {
      if (i === 0) {
        e.closest(".js-product-slideshow-thumb").classList.add("is-active-item");
      }
      e.addEventListener("click", this.setActiveMedia.bind(this, e));
    });

    this.hide_variant = this.dataset.hideVariantImage;
  }

  setActiveMedia(e) {
    let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);

    let activeThumb = e.closest("sht-vert-carousel-itm");

    if (!window.matchMedia("(max-width: 768px)").matches) {
      this.$$(".js-product-slideshow-item").forEach(element => {
        element.classList.remove("d-block");

        this.hide_variant == "true" && element.classList.add("d-none");
      });

      this.$$(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });

      activeMedia.classList.add("d-block");
      this.hide_variant == "true" && activeMedia.classList.remove("d-none");

      activeThumb.classList.add("is-active-item");
      this.playActiveVideo(activeMedia);
      this.playActiveModel(activeMedia);
    } else {
      this.pauseAllVideo();
      this.$$(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });
      activeThumb.classList.add("is-active-item");
      this.carousel.querySelector(".js-carousel-items").scrollTo({
        left: activeMedia.offsetLeft,
        behavior: "smooth",
      });
    }
  }

  pauseAllModel() {
    SHTHelper.qsa("sht-prd-media-itm-model").forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  pauseAllVideo() {
    this.$$(".js-media-item-youtube").forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    this.$$(".js-media-item-vimeo").forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });

    this.$$(".js-media-item-video").forEach(video => video.pause());
  }

  playActiveVideo(activeItem) {
    this.pauseAllVideo();
    // let deferredExternalVideo = activeItem.querySelector(
    //   ".js-product-media-deferred-video"
    // );

    //if (deferredExternalVideo) deferredExternalVideo.loadContent();
  }

  playActiveModel(activeItem) {
    //this.pauseAllModel();
    // let deferredExternalModel = activeItem.querySelector(
    //   ".js-product-media-deferred-model"
    // );
    // if (deferredExternalModel) deferredExternalModel.loadContent();
  }
}
customElements.define("sht-prd-slideshow", SHTProductSlideShow);

class SHTProductMediaItemDeferredVideo extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.itemDeferredVideoImageElem = this.$(".js-product-media-item-deferred-video-image");
    if (this.itemDeferredVideoImageElem) {
      this.itemDeferredVideoImageElem.addEventListener("click", event => {
        this.loadContent();
      });
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      let template = this.$("template").content.firstElementChild.cloneNode(true);
      this.appendChild(template);
      this.isLoaded(true);
      this.itemDeferredVideoImageElem && this.itemDeferredVideoImageElem.remove();
      return true;
    }
  }

  isLoaded(loaded) {
    if (loaded) {
      this.setAttribute("loaded", true);
    } else {
      this.removeAttribute("loaded");
    }
  }
}

customElements.define("sht-prd-media-itm-deferred-video", SHTProductMediaItemDeferredVideo);

class SHTProductMediaItemModel extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.itemModelImageElem = this.$(".js-product-media-item-model-image");
    if (this.itemModelImageElem) {
      this.itemModelImageElem.addEventListener("click", event => {
        this.loadContent();
      });
    }
  }

  loadModelViewerUICss() {
    if (!SHTHelper.qs("#model-viewer-ui")) {
      let productModelCssFile = document.createElement("link");
      productModelCssFile.setAttribute("href", `https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css`);
      // productModelCssFile.setAttribute("data-css-id", "model-viewer-ui");
      productModelCssFile.setAttribute("rel", "stylesheet");
      productModelCssFile.setAttribute("media", "all");
      productModelCssFile.setAttribute("id", "model-viewer-ui");
      document.getElementsByTagName("head")[0].appendChild(productModelCssFile);
    }
  }
  loadContent() {
    if (this.getAttribute("loaded")) return;

    let content = document.createElement("div");
    content.appendChild(this.$("template").content.firstElementChild.cloneNode(true));

    this.setAttribute("loaded", true);

    this.itemModelImageElem && this.itemModelImageElem.remove();
    this.appendChild(content.querySelector("model-viewer")).focus();
    this.loadModelViewerUICss();
    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(this.$("model-viewer"));
  }
}

customElements.define("sht-prd-media-itm-model", SHTProductMediaItemModel);

/* Map */
class SHTMap extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    //this.$ = this.querySelector.bind(this);
    this.iframe = this.$(".js-map-iframe");
    this.bindEventHandlers();
  }
  /**
   * Load Iframe Content
   */
  loadIframeContent() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.dispatchEvent(
              new CustomEvent("loadingStart", {
                detail: {
                  ele: this.iframe,
                  parent: this,
                },
              })
            );
            this.execute();
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px -100px 0px",
      }
    );
    observer.observe(this);
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.iframe.addEventListener(
      "load",
      function () {
        this.dispatchEvent(
          new CustomEvent("loadingEnd", {
            detail: {
              ele: this.iframe,
              parent: this,
            },
          })
        );
        this.setAttribute("loaded", true);
      }.bind(this)
    );
  }

  execute() {
    this.setIframeSrc();
  }
  /**
   * Apply Src top iframe
   */
  setIframeSrc() {
    let url = `https://maps.google.com/maps?z=${this.dataZoom}&t=${this.dataType}&q=${this.dataLocation.replace(/"/g, "")}&ie=UTF8&&output=embed`;
    this.iframe.src = url;
    this.iframe.removeAttribute("srcdoc");
  }
  /**
   * observe Attributes
   */
  static get observedAttributes() {
    return ["data-zoom", "data-type", "data-location"];
  }
  /**
   * check Attributes get changed or not
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (Shopify.designMode) {
        this.execute();
      } else {
        this.loadIframeContent();
      }
    }
  }
  /**
   * When the element is added to the DOM, the connectedCallback method is triggered
   */
  connectedCallback() {}
  /**
   * When the element is removed from the DOM, the disconnectedCallback method is triggered
   */
  disconnectedCallback() {}
  /**
   * get zoom prop
   */
  get dataZoom() {
    return this.getAttribute("data-zoom");
  }
  /**
   * get type prop
   */
  get dataType() {
    return this.getAttribute("data-type");
  }
  /**
   * get location prop
   */
  get dataLocation() {
    return this.getAttribute("data-location");
  }

  /**
   * Set zoom prop
   */
  set dataZoom(newValue) {
    this.setAttribute("data-zoom", newValue);
  }
  /**
   * Set type prop
   */
  set dataType(newValue) {
    this.setAttribute("data-type", newValue);
  }
  /**
   * Set location prop
   */
  set dataLocation(newValue) {
    this.setAttribute("data-location", newValue);
  }
}
customElements.define("sht-map", SHTMap);
/* Map */

class SHTMenuDrawer extends SHTCoreDrawer {}

customElements.define("sht-menu-drwer", SHTMenuDrawer);

class SHTMenuDrawerOpener extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.triggerBtnElement = this.$(".js-menu-drawer-trigger");
    this.menuDrawerElement = SHTHelper.qs("sht-menu-drwer");
    this.menuDrawerBodyElement = this.menuDrawerElement.querySelector(".js-menu-drawer-body");
    this.menuDrawerContentElement = SHTHelper.qs(".js-menu-drawer-content");
    this.triggerBtnElement.addEventListener("click", e => {
      this.menuDrawerBodyElement.innerHTML = this.menuDrawerContentElement.innerHTML;
      setTimeout(() => {
        this.menuDrawerElement.openDrawer(e.target);
      }, 0);
    });
  }
}

customElements.define("sht-menu-drwer-opner", SHTMenuDrawerOpener);

class SHTCarouselTrigger extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      setTimeout(() => {
        this.init();
      }, 1000);
    } else {
      this.init();
    }
  }

  init() {
    this.trigger = this.$$(".js-carousel-trigger");
    this.carouselWebElement = SHTHelper.qs(`#${this.dataset.carouselTarget}`);
    this.carousel = this.carouselWebElement.querySelector(`.js-carousel-items`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    for (let i = 0, n = this.trigger.length; i < n; i++) {
      this.trigger[i].addEventListener("click", event => {
        this.setActiveCarouselElement(event.currentTarget);
      });
    }

    this.carouselWebElement.addEventListener("itemChanged", e => {
      this.setButtonVisibility(false);
      let buttonElement = this.$(`[aria-describedby="${e.detail.currentElement.id}"]`);

      buttonElement.setAttribute("aria-current", "true");
      buttonElement.classList.add("hotspot-item--active");
    });
  }

  setActiveCarouselElement(el) {
    let carouselItem = this.carousel.querySelector(`#${el.getAttribute("aria-describedby", "")}`);

    if (carouselItem) {
      this.carousel.scrollTo({
        left: carouselItem.offsetLeft,
        behavior: "smooth",
      });
    }
  }

  setButtonVisibility(flag) {
    if (this.trigger) {
      for (let i = 0, n = this.trigger.length; i < n; i++) {
        if (flag) {
          this.trigger[i].setAttribute("aria-current", "true");
          this.trigger[i].classList.add("hotspot-item--active");
        } else {
          this.trigger[i].removeAttribute("aria-current");
          this.trigger[i].classList.remove("hotspot-item--active");
        }
      }
    }
  }
}
customElements.define("sht-carousel-trig", SHTCarouselTrigger);

// class SHTHotSpot extends SHTCustomComponent {
//   constructor() {
//     super();
//   }
//   init() {
//     this.tooltip_content = this.$(".js-tooltip-content");
//     this.tooltip_contents = this.$$(".js-tooltip-content");
//     this.tooltip_placeholders = this.$$(".js-tooltip-placeholder");
//     this.tooltip_container = SHTHelper.qs(`#${this.dataset.containerId}`);
//     this.bindEventHandlers();
//   }
//   bindEventHandlers() {
//     for (let i = 0, n = this.tooltip_placeholders.length; i < n; i++) {
//       let e = this.tooltip_placeholders[i];
//       e.addEventListener("mouseover", (elm) => {
//         this.handleToolTipContentPosition(elm);
//       });
//       e.addEventListener("mouseout", (elm) => {
//         for (let z = 0, m = this.tooltip_contents.length; z < m; z++) {
//           let content = this.tooltip_contents[z];
//           content.classList.remove(
//             "hotspot-content--right",
//             "hotspot-content--left",
//             "hotspot-content--top",
//             "hotspot-content--bottom",
//             "hotspot-content--show"
//           );
//         }
//       });
//     }
//   }

//   handleToolTipContentPosition(elm) {
//     let tooltipPlaceholder = elm.currentTarget;
//     let tooltipContent = tooltipPlaceholder.querySelector(
//       ".js-tooltip-content"
//     );

//     let axisX = Math.round(
//       tooltipPlaceholder.offsetLeft +
//         tooltipContent.offsetWidth +
//         tooltipPlaceholder.offsetWidth
//     );

//     let axisY = Math.round(
//       tooltipPlaceholder.offsetTop +
//         tooltipContent.offsetHeight +
//         tooltipPlaceholder.offsetHeight
//     );

//     if (
//       tooltipPlaceholder.offsetLeft >= 0 &&
//       tooltipPlaceholder.offsetLeft < this.tooltip_container.offsetWidth &&
//       axisX < this.tooltip_container.offsetWidth
//     ) {
//       tooltipContent.classList.add(
//         "hotspot-content--right",
//         "hotspot-content--show"
//       );
//     } else if (
//       tooltipPlaceholder.offsetLeft >= 0 &&
//       tooltipPlaceholder.offsetLeft < this.tooltip_container.offsetWidth &&
//       axisX >= this.tooltip_container.offsetWidth
//     ) {
//       tooltipContent.classList.add(
//         "hotspot-content--left",
//         "hotspot-content--show"
//       );
//     } else {
//       //do nothing
//     }

//     if (
//       tooltipPlaceholder.offsetTop >= 0 &&
//       tooltipPlaceholder.offsetTop < this.tooltip_container.offsetHeight &&
//       axisY < this.tooltip_container.offsetHeight
//     ) {
//       tooltipContent.classList.add("hotspot-content--bottom");
//     } else if (
//       tooltipPlaceholder.offsetTop >= 0 &&
//       tooltipPlaceholder.offsetTop < this.tooltip_container.offsetHeight &&
//       axisY >= this.tooltip_container.offsetHeight
//     ) {
//       tooltipContent.classList.add("hotspot-content--top");
//     } else {
//       //do nothing
//     }
//   }

//   connectedCallback() {
//     if (Shopify.designMode) {
//       setTimeout(() => {
//         this.init();
//       }, 1000);
//     } else {
//       this.init();
//     }
//   }
// }
// customElements.define("sht-hotspot", SHTHotSpot);

/* SHT Accordion */
class SHTAccordion extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    // this.$$ = this.querySelectorAll.bind(this);
    this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {};

    this.accordionItems = this.$$(".js-accordion-item");
    this.accordionTriggers = this.$$(".js-accordion-trigger");
    this.accordionTrigger = this.$(".js-accordion-trigger");
    this.accordionContents = this.$$(".js-accordion-content");

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.accordionTriggers.forEach(ele => {
      ele.addEventListener("click", e => {
        e.preventDefault();
        this.onTriggerClick(e.currentTarget);
      });
    });
  }

  onTriggerClick(e) {
    let open = e.getAttribute("aria-expanded") === "true";
    if (!this.properties.multiple) {
      this.toggleAll();
    }
    this.toggle(!open, e);
  }

  toggle(open, e) {
    e.setAttribute("aria-expanded", `${open}`);
    if (open) {
      e.classList.add("open");
    } else {
      e.classList.remove("open");
    }

    let content = this.$(`#${e.getAttribute("aria-controls")}`);

    if (open) {
      //content.removeAttribute("hidden");
      content.classList.add("open");
      content.style.maxHeight = `${this.calculateMaxHeightContent(content)}px`;
    } else {
      // content.setAttribute("hidden", "");
      content.classList.remove("open");
      content.style.maxHeight = `0px`;
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }

  toggleAll() {
    this.accordionTriggers.forEach(ele => {
      ele.setAttribute("aria-expanded", `false`);
      ele.classList.remove(`open`);
    });

    this.accordionContents.forEach(ele => {
      //ele.setAttribute("hidden", "");
      ele.classList.remove("open");
      ele.style.maxHeight = `0px`;
    });
  }

  calculateMaxHeightContent(target) {
    return target.scrollHeight;
  }
}

customElements.define("sht-accordion", SHTAccordion);
/* SHT Accordion */

class SHTFeaturedVariantSelector extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.elms = {
      radio_elms: this.$$(".js-featured-variant-radio-item"),
      form: SHTHelper.qs(`#featuredProductForm-${this.dataset.section}`),
      price: SHTHelper.qs(`#featuredProductPrice-${this.dataset.section}`),
      product_form: SHTHelper.qs(`sht-featured-prd-frm[data-section="${this.dataset.section}"]`),
      inventory_tracking: SHTHelper.qs(`#featuredInventoryTracking-${this.dataset.section}`),
      sku: SHTHelper.qs(`#featuredSku-${this.dataset.section}`),
      variant_picker: SHTHelper.qs(`#featuredVariantPicker-${this.dataset.section}`),
      quantity_input: SHTHelper.qs(`#featuredProductQuantity-${this.dataset.section}`),
      slideshow: SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`),
      thumb_carousel: SHTHelper.qs(`sht-vert-carousel[data-section="${this.dataset.section}"]`),
      carousel: SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`),
      variant_options: this.$$(".js-variant-option-value"),
    };

    this.price_selector = `#featuredProductPrice-${this.dataset.section}`;
    this.inventory_tracking_selector = `#featuredInventoryTracking-${this.dataset.section}`;
    this.sku_selector = `#featuredSku-${this.dataset.section}`;
    this.variant_picker_selector = `#featuredVariantPicker-${this.dataset.section}`;
    this.quantity_input_selector = `#featuredProductQuantity-${this.dataset.section}`;

    this.slideshow_selector = `sht-prd-slideshow[data-section="${this.dataset.section}"]`;

    this.variantData = this.setSelectedVariants(this);

    this.updateSelectedVariants(this.variantData);
    this.bindEventHandlers();
  }

  updateSelectedVariants(variant) {
    if (!variant?.options) return;

    variant.options.forEach((e, index) => {
      const variantValue = `${e}-${index}`.replace(/"/g, '\\"');
      const selectedElement = this.$(`.js-variant-item[data-variant-value="${variantValue}"]`);
      if (selectedElement) {
        const variantName = selectedElement.getAttribute("data-variant-name") || selectedElement.getAttribute("name");
        const optionValue = selectedElement.dataset.optionVariantValue;
        if (variantName) {
          const targetElement = this.$(`.js-variant-radio-option-name[data-option-name="${variantName.replace(/"/g, '\\"')}"]`);
          if (targetElement) targetElement.innerHTML = e;

          const targetSelectElement = this.$(`.js-variant-select-option-name[data-option-name="${variantName.replace(/"/g, '\\"')}"]`);
          if (targetSelectElement) {
            targetSelectElement.innerHTML = optionValue || e;
          }
        }
      }
    });
  }

  setSelectedVariants(node) {
    return JSON.parse(node.querySelector('[data-selected-variant][type="application/json"]').textContent);
  }


  bindEventHandlers() {
    this.addEventListener("change", this.onVariantChangeHandle.bind(this));
  }

  onVariantChangeHandle() {
    this.toggleAddButton(true);
    this.removeErrorMessage();
    this.renderProductInfo();
  }

  setSelectOptionAvailability(option_inputs, available_option_inputs_value) {
    option_inputs.forEach(input => {
      if (available_option_inputs_value.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = SHTLanguage.product.PRODUCT_UNAVAILABLE_WITH_OPTION.replace("[value]", input.getAttribute("value"));
      }
    });
  }

  removeErrorMessage() {
    if (this.elms.product_form) this.elms.product_form.handleErrorMessage();
  }

  getSelectedVariantValue() {
    return Array.from(this.querySelectorAll('.js-variant-item:checked')).map(el => el.dataset.optionValueId);
  }

  buildRequestUrlWithParams(url, optionValues) {
    const params = new URLSearchParams({ section_id: this.dataset.section });
    if (optionValues.length) params.append("option_values", optionValues.join(","));
    return `${url}?${params.toString()}`;
  }

  async renderProductInfo() {
    const productUrl = this.dataset.url;
    const optionValues = this.getSelectedVariantValue();
    const requestUrl = this.buildRequestUrlWithParams(productUrl, optionValues);

    try {
      const response = await fetch(requestUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const html = await response.text();
      const markup = new DOMParser().parseFromString(html, "text/html");

      const variant = this.setSelectedVariants(markup);

      if (!variant) return this.setUnavailable();

      this.updateUI(markup, variant);
    } catch (err) {
      console.error("Error fetching product info:", err);
      this.setUnavailable();
    }
  }

  checkInventory(markup) {
    const dest = this.elms.inventory_tracking;
    const src = markup.querySelector(this.inventory_tracking_selector);
    console.log(dest, src);
    if (dest) dest.innerHTML = src?.innerHTML ?? "";
  }

  updateUI(markup, variant) {
    this.checkInventory(markup);
    this.updateVariantInput(variant);
    this.updateOptionValues(markup);

    this.setActiveMedia(variant);
    this.updatePrice(markup);
    this.updateSku(markup);
    this.updateQuantity(markup);
    this.updateSelectOptions(markup, variant);
    this.updateSlideshow(markup);
    this.updateAddToCartState(variant);
  }

  updatePrice(markup) {
    const src = markup.querySelector(this.price_selector);
    if (src && this.elms.price) {
      this.elms.price.innerHTML = src.innerHTML;
      this.elms.price.classList.remove("d-none-important");
    }
  }

  updateAddToCartState(variant) {
    this.toggleAddButton(!variant.available, SHTLanguage.product.PRODUCT_SOLD_OUT);
  }

  updateSlideshow(markup) {
    if (this.elms.slideshow?.hide_variant === "false") {
      const src = markup.querySelector(this.slideshow_selector);
      if (src && this.elms.slideshow) {
        this.elms.slideshow.innerHTML = src.innerHTML;
        this.elms.slideshow.bindEventHandlers();
      }
    }
  }

  updateSelectOptions(markup, variant) {
    const srcItems = markup.querySelectorAll('sht-select .js-variant-select-item');
    const destItems = this.querySelectorAll('sht-select .js-variant-select-item');
    srcItems.forEach((src, i) => {
      if (destItems[i]) destItems[i].innerHTML = src.innerHTML;
    });
    this.updateSelectedVariants(variant);
  }

  updateQuantity(markup) {
    const msgDest = this.elms.quantity_input?.querySelector('.js-max-quantity-message');
    const msgSrc = markup.querySelector(this.quantity_input_selector)?.querySelector('.js-max-quantity-message');
    if (msgDest) {
      msgDest.classList.add('d-none-important');
      msgDest.innerHTML = msgSrc?.innerHTML ?? "";
    }
    const inputSrc = markup.querySelector(this.quantity_input_selector);
    if (this.elms.quantity_input) this.elms.quantity_input.innerHTML = inputSrc?.innerHTML ?? "";
  }

  updateSku(markup) {
    const src = markup.querySelector(this.sku_selector);
    if (this.elms.sku) this.elms.sku.innerHTML = src?.innerHTML ?? "";
  }

  updateOptionValues(markup) {
    const src = markup.querySelector('.js-variant-picker');
    const dest = this.elms.variant_picker;
    if (src && dest) dest.innerHTML = src.innerHTML;
  }

  updateVariantInput(variant) {
    if (!variant) return;
    const forms = [this.elms.form, this.elms.installment_form];
    const stockStatus = SHTHelper.qs('.js-inventory-tracking');
    console.log(stockStatus);
    stockStatus?.classList.remove('d-none');
    forms.forEach(f => {
      if (f) {
        const input = f.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  }

  setActiveMedia(variant) {
    if (variant.featured_media) {
      let mediaId = variant.featured_media.id;

      let activeMedia = this.elms.slideshow.querySelector(`sht-carousel-itm[data-media-id="${this.dataset.section}-${mediaId}"]`);

      let activeThumb = this.elms.slideshow.querySelector(`sht-vert-carousel-itm[data-media-target-id="${this.dataset.section}-${mediaId}"]`);

      if (!window.matchMedia("(max-width: 768px)").matches) {
        this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach(element => {
          element.classList.remove("d-block");
          this.elms.slideshow.hide_variant == "true" && element.classList.add("d-none");
        });

        this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
          element.classList.remove("is-active-item");
        });

        activeMedia.classList.add("d-block");
        this.elms.slideshow.hide_variant == "true" && activeMedia.classList.remove("d-none");

        if (activeThumb) {
          activeThumb.classList.add("is-active-item");
          this.elms.thumb_carousel.querySelector(".js-carousel-items").scrollTo({
            top: activeThumb.offsetTop,
            behavior: "auto",
          });
        }
      } else {
        this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
          element.classList.remove("is-active-item");
        });

        this.elms.carousel.querySelector(".js-carousel-items").scrollTo({
          left: activeMedia.offsetLeft,
          behavior: "smooth",
        });

        if (activeThumb) {
          activeThumb.classList.add("is-active-item");
          this.elms.thumb_carousel.querySelector(".js-carousel-items").scrollTo({
            left: activeThumb.offsetLeft,
            behavior: "auto",
          });
        }
      }

      this.elms.slideshow.pauseAllVideo();
    }
  }
  setUnavailable() {
    let form = this.elms.form;
    if (!form) return;
    let addBtn = form.querySelector(".js-featured-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-featured-product-form-submit-btn-text");
    if (!addBtn) return;

    addBtnText.textContent = SHTLanguage.product.PRODUCT_UNAVAILABLE;
    if (this.elms.inventory_tracking) this.elms.inventory_tracking.classList.add("d-none");
    if (this.elms.price) this.elms.price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variant_data = this.variant_data || JSON.parse(this.$('[type="application/json"]').textContent);
    this.variant_data.map(e => {
      e.my_options = [];
      e.options.forEach((elm, index) => {
        e.my_options.push(`${elm}-${index}`);
      });
    });
    return this.variant_data;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let form = this.elms.form;

    if (!form) return;
    let addBtn = form.querySelector(".js-featured-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-featured-product-form-submit-btn-text");

    if (!addBtn) return;

    if (disable) {
      addBtn.setAttribute("disabled", "disabled");
      if (text) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      addBtnText.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART;
    }

    if (!modifyClass) return;
  }
}

class SHTFeaturedVariantRadios extends SHTFeaturedVariantSelector {
  constructor() {
    super();

    //this.$$ = this.querySelectorAll.bind(this);
  }
}

customElements.define("sht-featured-variant-radios", SHTFeaturedVariantRadios);


class SHTFeaturedVariantSelects extends SHTFeaturedVariantSelector {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.select_type = "dropdown";
  }

}
customElements.define("sht-featured-variant-selects", SHTFeaturedVariantSelects);

class SHTFeaturedVariantSwatchSelect extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }

  init() {
    this.radios = this.$$(".js-variant-radio-item");
    this.select_id = this.dataset.selectId;
    this.select_element = document.querySelector(`#${this.select_id}`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.radios.forEach(radio => {
      radio.addEventListener("click", e => {
        e.preventDefault();
        Array.from(this.radios, input => {
          input.checked = false;
        });

        setTimeout(() => {
          e.target.checked = true;
        });
        if (this.select_element) {
          let option = this.select_element.querySelector(`option[value="${e.target.value.replace(/"/g, '\\"')}"]`);
          option.selected = true;
          this.select_element.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        }
      });
    });
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("sht-featured-variant-swatch-select", SHTFeaturedVariantSwatchSelect);

class SHTFeaturedProductForm extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    //this.$ = this.querySelector.bind(this);

    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-featured-product-form-error-wrapper"),
      error_message: this.$(".js-featured-product-form-error-message"),
      spinner: this.$(".js-featured-product-form-spinner"),
      quantity_input_container: SHTHelper.qs(`#featuredProductQuantity-${this.dataset.section}`),
      sticky_header: SHTHelper.qs("sht-sticky-header"),
      announcement_bar: SHTHelper.qs("sht-ann-bar"),
      header_cart_status: SHTHelper.qs("#headerCartStatus"),
    };

    this.cartNotification = SHTHelper.qs("sht-cart-noti");

    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");
    this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm");
    this.mainCartForm = SHTHelper.qs("sht-cart-frm");
    if (this.elms.form) {
      this.elms.form.querySelector("[name=id]").disabled = false;
      this.bindEventHandlers();
    }
  }

  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    // this.cartNotification &&
    //   this.cartNotification.setActiveElement(document.activeElement);
  }
  onSubmitHandler(e) {
    e.preventDefault();

    if (this.elms.submit_btn.classList.contains("loading")) return;
    this.handleErrorMessage();

    this.elms.submit_btn.setAttribute("aria-disabled", true);
    this.elms.submit_btn.setAttribute("disabled", true);
    this.elms.submit_btn.classList.add("loading");

    this.elms.spinner.classList.remove("hidden");

    if (this.elms.header_cart_status) {
      this.elms.header_cart_status.classList.remove("header-cart-status--animate");
    }

    let sections = this.cartNotification.getSectionsToRender();
    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender()];
    }

    if (this.mainCartForm) {
      sections = [...sections, ...this.mainCartForm.getSectionsToRender(false)];
    }
    let formData = new FormData(this.elms.form);
    formData.append(
      "sections",
      sections.map(section => section.id)
    );
    formData.append("sections_url", window.location.pathname);
    SHTHelper.fetchConfigHTTP.body = formData;

    fetch(`${routes.cart_add_url}`, SHTHelper.fetchConfigHTTP)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        if (!response.id) {
          response.id = formData.get("id");
        }
        // if (this.elms.sticky_header) {
        //   if (this.elms.sticky_header.dataset.isEnabled) {
        //     this.elms.sticky_header.reveal();
        //   }
        // }

        this.cartNotification.renderContents(response);
        if (this.cartDrawerForm) {
          this.cartDrawerForm.renderContents(response);
        }
        if (this.mainCartForm) {
          this.mainCartForm.renderContents(response);
        }
        if (this.elms.quantity_input_container && this.elms.quantity_input_container.dataset.show == "add-to-cart") {
          this.elms.quantity_input_container.classList.remove("d-none");
          this.elms.quantity_input_container.querySelector("input").value = 1;
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.elms.submit_btn.classList.remove("loading");
        this.elms.submit_btn.removeAttribute("aria-disabled");
        this.elms.submit_btn.removeAttribute("disabled");
        this.elms.spinner.classList.add("hidden");
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.elms.error_wrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.elms.error_message.textContent = errorMessage;
    }
  }
}

customElements.define("sht-featured-prd-frm", SHTFeaturedProductForm);

class SHTProductComparison extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.view_button = this.$(".js-product-comparison-view-more-btn");
    this.view_button_label = this.$(".js-product-comparison-view-more-btn-label");
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.view_button?.addEventListener("click", e => {
      this.hidden_elements = this.$$(".js-product-comparison-hidden-item");
      this.view_button.classList.toggle("is-more", !this.view_button.classList.contains("is-more"));
      this.view_button_label.textContent = !this.view_button.classList.contains("is-more") ? this.view_button.dataset.viewMore : this.view_button.dataset.viewLess;
      for (let i = 0, n = this.hidden_elements.length; i < n; i++) {
        this.hidden_elements[i].classList.toggle("d-none-important", !this.hidden_elements[i].classList.contains("d-none-important"));
      }
    });
  }

  connectedCallback() {
    this.init();
  }
}
customElements.define("sht-product-comparison", SHTProductComparison);

class SHTTabs extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.tabLinks = this.$$(".js-tab-link");
    this.tabPanels = this.$$(".js-tab-panel");
    this.bindEventHandlers();
  }

  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.tabLinks.forEach(
      function (e, k, p) {
        e.addEventListener(
          "click",
          function (evt) {
            evt.preventDefault();
            this.tabLinkEventHandler(evt.target);
          }.bind(this)
        );
      }.bind(this)
    );
  }

  tabLinkEventHandler(e) {
    let id = e.getAttribute("href").replace("#", "");
    this.tabPanels.forEach(
      function (e) {
        e.classList.remove("d-block", "tab__panel--active");
        e.classList.add("d-none");
      }.bind(this)
    );

    this.tabLinks.forEach(
      function (e) {
        e.classList.remove("tab__link--active");
      }.bind(this)
    );

    let currentPanel = this.$(`[data-tab-content-id=${id}]`);
    currentPanel.classList.remove("d-none");
    currentPanel.classList.add("d-block", "tab__panel--active");

    e.classList.add("tab__link--active");
  }
  /**
   * When the element is added to the DOM, the connectedCallback method is triggered
   */
  connectedCallback() {}
  /**
   * When the element is removed from the DOM, the disconnectedCallback method is triggered
   */
  disconnectedCallback() {}
}
customElements.define("sht-tabs", SHTTabs);

class SHTReadMore extends SHTCustomComponent {
  constructor() {
    super();
  }
  init() {
    this.content = this.$(".js-expandable-content");
    this.btn = this.$(".js-expandable-content-btn");
    if (this.content.scrollHeight > this.content.clientHeight) {
      this.content.classList.add("expandable-content--expandable");
    } else {
      this.content.setAttribute("data-expanded", "true");
    }
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    let clientHeight = this.content.clientHeight;
    this.btn.addEventListener("click", e => {
      if (this.content.getAttribute("data-expanded") === "true") {
        this.content.setAttribute("data-expanded", "false");
        this.content.style.maxHeight = `${clientHeight}px`;
        this.btn.innerHTML = this.btn.getAttribute("data-view-more");
      } else {
        this.content.setAttribute("data-expanded", "true");
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        this.btn.innerHTML = this.btn.getAttribute("data-view-less");
      }
    });
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("sht-read-more", SHTReadMore);

class SHTMovingImage extends SHTCustomComponent {
  constructor() {
    super();
  }
  init() {
    this.moving_image_container = this.$(".js-moving-image-container");
    this.moving_image_container;

    this.moving_image_container.style.setProperty("--container-height", `${this.moving_image_container.offsetHeight}px`);

    window.addEventListener("resize", e => {
      this.moving_image_container.style.setProperty("--container-height", `${this.moving_image_container.offsetHeight}px`);
    });
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("sht-moving-image", SHTMovingImage);
if (!customElements.get("sht-predictive-srch")) {
  class SHTPredictiveSearch extends SHTCustomComponent {
    constructor() {
      super();

      this.cachedRequests = new Map();
      this.resultsPanelMaxHeight = 0;
      this.elms = {
        predictive_search_form: this.$(`.js-predictive-search-form`),
        predictive_search_input: this.$(`.js-predictive-search-input`),
        predictive_search_results: this.$(`.js-predictive-search-results`),
        predictive_search_result_panel: this.$(`.js-predictive-search-results-panel`),
        predictive_search_result_items: this.$(`.js-predictive-search-result-items`),
        predictive_search_message_placeholder: this.$(`.js-predictive-search-message-placeholder`),
        predictive_search_loading: this.$(".js-predictive-search-loading"),
        predictive_close_button: this.$(".js-predictive-search-close-trigger"),
        header: this.closest("sht-header"),
        header_search_open_trigger: this.closest("sht-header")?.querySelector(".js-search-open-trigger"),
        predictive_search_product_type: this.$(".js-predictive-search-product-type"),
        predictive_search_btn_open_product_type: this.$(".js-predictive-search-btn-open-product-type"),
        body: document.body,
        product_type: this.$(`.js-search-product-type`),
      };
      let dataSearchType = this.getAttribute("data-search-type");
      if (dataSearchType != "") {
        dataSearchType = "product," + dataSearchType;
      } else {
        dataSearchType = "product";
      }
      this.url = {
        searchUrl: routes.predictive_search_url,
        queryParameters: {
          section_id: "sht-predictive-srch",
          resources: {
            type: dataSearchType,
            limit: 10,
            options: {
              unavailable_products: "last",
              fields: "product_type",
            },
          },
        },
      };

      this.shopifyFeaturesJson = JSON.parse(SHTHelper.qs(`#shopify-features[type="application/json"]`).textContent);

      this.code = "";
      this.bindEventHandlers();
    }

    bindEventHandlers() {
      this.elms.predictive_search_form.addEventListener("submit", this.onSubmitHandle.bind(this));

      this.elms.predictive_search_input.addEventListener(
        "input",
        SHTHelper.debounce(event => {
          this.onInputHandle(event);
        }, 300).bind(this)
      );

      this.elms.predictive_search_product_type?.addEventListener("change", e => {
        if (this.elms.product_type) this.elms.product_type.value = this.elms.predictive_search_product_type.value;

        this.elms.predictive_search_product_type.value !== "" ? this.elms.predictive_search_btn_open_product_type.classList.add("field__search_icon--active") : this.elms.predictive_search_btn_open_product_type.classList.remove("field__search_icon--active");
        this.elms.predictive_search_input.dispatchEvent(new Event("input"));
      });
      this.elms.predictive_search_input.addEventListener("focus", this.onInputFocusHandle.bind(this));

      this.addEventListener("focusout", this.onFocusOutHandle.bind(this));

      this.elms.predictive_close_button.addEventListener("click", this.closeSearchResults.bind(this));

      this.addEventListener("keyup", event => {
        this.code = event.code.toUpperCase();

        event.code.toUpperCase() === "ESCAPE" && this.closeSearchResults();
      });
    }

    onInputFocusHandle(e) {
      let searchTerm = this.getSearchTerm();
      this.openSearchResults(searchTerm);
    }

    getSearchTerm() {
      return this.elms.predictive_search_input.value.trim();
    }

    openSearchResults(searchTerm) {
      if (!searchTerm.length) {
        this.resetSearchResultPanel();
        this.togglePlaceHolderMessage(true);
        this.toggleLoading(false);
        this.toggleLoadingContainer(false);
        this.toggleResults(false);
      } else {
        this.togglePlaceHolderMessage(false);
      }

      this.toggleOpen(true);
      this.toggleSearchResults(true);
      this.elms.predictive_search_input.setAttribute("aria-expanded", true);
    }

    resetSearchResultPanel() {
      this.elms.predictive_search_result_items.innerHTML = "";
    }

    toggleResults(results) {
      if (results) {
        this.setAttribute("results", true);
        setTimeout(
          function () {
            this.classList.add("is-result-show");
          }.bind(this),
          300
        );
      } else {
        this.removeAttribute("results");
        this.classList.remove("is-result-show");
      }
      return;
    }

    toggleOpen(open) {
      if (open) {
        this.setAttribute("open", true);
        this.elms.header.classList.add("header--predictive-search-open");
        this.elms.body.classList.add("o-hidden");
      } else {
        this.removeAttribute("open");
        this.elms.header.classList.remove("header--predictive-search-open");
        this.elms.body.classList.remove("o-hidden");
      }
      return;
    }

    async onInputHandle(e) {
      if (!this.shopifyFeaturesJson.predictiveSearch || this.code === "ESCAPE") {
        return;
      }

      let searchTerm = this.getSearchTerm();
      this.openSearchResults(searchTerm);
      this.resetSearchResultPanel();
      if (!searchTerm.length) {
        return;
      }

      if (this.dataset.showSearchFilter === "false") {
        let markup = await this.getSearchResults(searchTerm);
        this.renderSearchResultPanel(markup);
      } else {
        let markup = await this.getSearchResultsWithMultipleRequests(searchTerm);
        this.renderSearchResultPanel(markup);
      }
    }

    buildUrl(searchTerm) {
      let urls = [];
      if (this.elms.predictive_search_product_type.value != "") {
        let url = `${this.url.searchUrl}?q=product_type:${encodeURIComponent(this.elms.predictive_search_product_type.value + " AND " + searchTerm)}&resources[limit]=10&resources[limit_scope]=each&resources[type]=product&section_id=predictive-search`;
        urls.push(fetch(url));
      } else {
        let url = `${this.url.searchUrl}?q=${encodeURIComponent(searchTerm)}&resources[limit]=10&resources[limit_scope]=each&resources[type]=product&section_id=predictive-search`;
        urls.push(fetch(url));
      }

      if (this.getAttribute("data-search-type")) {
        let url = `${this.url.searchUrl}?q=${encodeURIComponent(searchTerm)}&resources[type]=${this.getAttribute("data-search-type")}&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search`;
        urls.push(fetch(url));
      }

      return urls;
    }

    async getSearchResultsWithMultipleRequests(searchTerm) {
      let qKey = this.elms.predictive_search_product_type.value.replace(/\s/g, "-").toLowerCase() + searchTerm.replace(/\s/g, "-").toLowerCase();

      let cached = this.cachedRequests.get(qKey);

      if (!cached) {
        let urls = this.buildUrl(searchTerm);
        let markup = await this.fetchResultsWithMultipleRequests(urls);
        this.cachedRequests.set(qKey, markup);
        return markup;
      }
      return cached;
    }

    async fetchResultsWithMultipleRequests(urls) {
      this.toggleLoading(true);
      this.toggleLoadingContainer(true);
      let results = await Promise.all(urls)
        .then(function (responses) {
          return Promise.all(
            responses.map(function (response) {
              return response.text();
            })
          );
        })
        .then(
          function (data) {
            let html = "";
            this.toggleLoading(false);
            this.toggleLoadingContainer(false);
            for (let i = 0, l = data.length; i < l; i++) {
              let resultsMarkup = new DOMParser().parseFromString(data[i], "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
              html += resultsMarkup;
            }
            return html;
          }.bind(this)
        )
        .catch(
          function (error) {
            this.closeSearchResults();
            console.error(error);
            return "";
          }.bind(this)
        );
      return results;
    }

    renderSearchResultPanel(markup) {
      this.elms.predictive_search_result_items.innerHTML = markup;
      this.toggleResults(true);
      this.toggleLoading(false);
      this.toggleLoadingContainer(false);

      /*this.elms.predictive_search_result_panel.style.maxHeight =
      this.resultsPanelMaxHeight ||
      `${this.calculateResultsPanelMaxHeight()}px`;*/
      SHTHelper.trapFocus(this);
    }

    async getSearchResults(searchTerm) {
      let qKey = searchTerm.replace(/\s/g, "-").toLowerCase();

      let cached = this.cachedRequests.get(qKey);

      if (!cached) {
        let markup = await this.fetchResults(searchTerm);
        this.cachedRequests.set(qKey, markup);
        return markup;
      }
      return cached;
    }

    onSubmitHandle(e) {
      let searchTerm = this.getSearchTerm();
      if (!searchTerm) {
        e.preventDefault();
      }
      this.$(`input[name="type"]`).value = "product";
    }

    async fetchResults(q) {
      let url = `${this.url.searchUrl}?q=${encodeURIComponent(q)}&resources[type]=${this.url.queryParameters.resources.type}&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search`;
      this.toggleLoading(true);
      this.toggleLoadingContainer(true);
      let results = await fetch(url)
        .then(response => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.closeSearchResults();
            throw error;
          }
          return response.text();
        })
        .then(text => {
          this.toggleLoading(false);
          this.toggleLoadingContainer(false);
          const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
          return resultsMarkup;
        })
        .catch(error => {
          this.closeSearchResults();
          console.error(error);
          return "";
        });
      return results;
    }

    toggleSearchResults(show) {
      if (!this.shopifyFeaturesJson.predictiveSearch) {
        show = false;
      }

      if (show) {
        this.elms.predictive_search_results.toggleAttribute("hidden", false);
      } else {
        this.elms.predictive_search_results.setAttribute("hidden", true);
      }
      return;
    }

    toggleLoading(loading) {
      if (loading) {
        this.elms.predictive_search_loading.toggleAttribute("hidden", false);
      } else {
        this.elms.predictive_search_loading.setAttribute("hidden", true);
      }
      return;
    }

    togglePlaceHolderMessage(show) {
      if (show) {
        this.elms.predictive_search_message_placeholder.toggleAttribute("hidden", false);
      } else {
        this.elms.predictive_search_message_placeholder.setAttribute("hidden", true);
      }
      return;
    }

    onFocusOutHandle(e) {
      let isMobile = window.matchMedia("(max-width: 768px)").matches;
      setTimeout(() => {
        if (!this.contains(document.activeElement) && !isMobile) {
          this.closeSearchResults(true);
        }
      });
    }

    toggleLoadingContainer(loading) {
      if (loading) {
        this.setAttribute("loading", true);
      } else {
        this.removeAttribute("loading");
      }
      return;
    }

    closeSearchResults(removeFocus = false) {
      this.toggleOpen(false);
      this.toggleLoading(false);
      this.toggleLoadingContainer(false);
      this.togglePlaceHolderMessage(false);
      this.toggleResults(false);
      this.resetSearchResultPanel();
      this.toggleSearchResults(false);

      if (this.elms.header_search_open_trigger && !removeFocus) {
        SHTHelper.removeTrapFocus(this.elms.header_search_open_trigger);
      }

      this.resultsPanelMaxHeight = 0;
      this.elms.predictive_search_result_panel.removeAttribute("style");
      this.elms.predictive_search_input.value = "";
      this.elms.predictive_search_input.setAttribute("aria-expanded", false);
    }

    calculateResultsPanelMaxHeight() {
      this.resultsPanelMaxHeight = window.innerHeight - SHTHelper.qid("shopify-section-header").getBoundingClientRect().bottom;
      return this.resultsPanelMaxHeight;
    }
  }

  customElements.define("sht-predictive-srch", SHTPredictiveSearch);
}

window.SHTProductMediaItemModel = {
  isMouseenter: false,
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR());
      return;
    }

    SHTHelper.qsa('[id^="ProductJSON-"]').forEach(modelJSON => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

if (Shopify.designMode) {
  SHTHelper.qsa("[data-shopify-xr-hidden]").forEach(element => element.classList.add("hidden"));
  if (window.SHTProductMediaItemModel) window.SHTProductMediaItemModel.loadShopifyXR();
} else {
  if (window.SHTProductMediaItemModel) {
    window.addEventListener(
      "scroll",
      function (event) {
        if (!window.SHTProductMediaItemModel.isMouseenter) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
        window.SHTProductMediaItemModel.isMouseenter = true;
      },
      false
    );
    ["mouseenter", "touchstart", "mouseover"].forEach(function (e) {
      SHTHelper.qs("body").addEventListener(e, function (event) {
        if (!window.SHTProductMediaItemModel.isMouseenter) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
        window.SHTProductMediaItemModel.isMouseenter = true;
      });
    });
  }
}

function SHTInitStyleVariable() {
  let SHTHeaderObj = SHTHelper.qs("sht-header");
  let SHTTopbar = SHTHelper.qs(".js-top-bar");
  let SHTPredictiveSearch = SHTHelper.qs("sht-predictive-srch");
  let SHTHeaderLogo = SHTHelper.qs(".js-header-logo");
  SHTHelper.qde.style.setProperty("--header-height", SHTHeaderObj ? `${SHTHeaderObj.offsetHeight}px` : "0px");
  SHTHelper.qde.style.setProperty("--header-width", SHTHeaderObj ? `${SHTHeaderObj.offsetWidth}px` : "0px");
  SHTHelper.qde.style.setProperty("--top-bar-height", SHTTopbar ? `${SHTTopbar.offsetHeight}px` : "0px");
  SHTHelper.qde.style.setProperty("--predictive-search-top", SHTPredictiveSearch ? `${SHTPredictiveSearch.offsetTop}px` : "0px");
  SHTHelper.qde.style.setProperty("--header-logo-width", SHTHeaderLogo ? `${SHTHeaderLogo.offsetWidth}px` : "0px");
  SHTHelper.qde.style.setProperty("--scrollbar-width", `${window.innerWidth - document.body.offsetWidth}px`);
}

["mousemove", "touchstart"].forEach(function (e) {
  SHTHelper.qs("body").addEventListener(
    e,
    function (event) {
      document.body.classList.add("is-body-hover");
      window.requestAnimationFrame(SHTInitStyleVariable);
      // SHTHelper.loadScript("popup-file", window.routes.popup_file_url, function () {
      //   console.log("Popup file is loaded");
      // });
    },
    { once: true }
  );
});

window.addEventListener(
  "scroll",
  function (event) {
    document.body.classList.add("is-body-hover");
    window.requestAnimationFrame(SHTInitStyleVariable);
    // SHTHelper.loadScript("popup-file", window.routes.popup_file_url, function () {
      //console.log("Popup file is loaded");
    // });
  },
  { once: true }
);

window.addEventListener("resize", e => {
  window.requestAnimationFrame(SHTInitStyleVariable);
});

class SHTDialogQuickBuy extends SHTDialogCore {
  constructor() {
    super();
  }

  showModal(opener) {
    SHTHelper.preventStickyHeaderReveal();
    this.opener = opener;
    this.opener?.setAttribute("disabled", "disabled");
    this.processData(opener);
  }

  processData(opener) {
    this.productElement = null;
    fetch(opener.getAttribute("data-product-url"))
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        this.productElement = responseHTML.querySelector(".section-product-quick-buy");

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        this.body.innerHTML = this.productElement.innerHTML;

        this.executeScriptElements(this.body);
        if (window.SHTProductMediaItemModel) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
      })
      .finally(() => {
        this.toggleAttribute("hidden", false);
        this.classList.add("is-active");

        this.opener?.removeAttribute("disabled");
      });
  }

  closeModal() {
    this.setAttribute("hidden", true);
    this.classList.remove("is-active");

    setTimeout(() => {
      this.body.innerHTML = "";
    }, 300);
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");

    Array.from(scriptElements).forEach(scriptElement => {
      const clonedElement = document.createElement("script");

      Array.from(scriptElement.attributes).forEach(attribute => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });

      clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }
}
customElements.define("sht-dialog-quickbuy", SHTDialogQuickBuy);

class SHTMarquee extends SHTCustomComponent {
  constructor() {
    super();

  }

  connectedCallback() {
    this.init();
  }

  calculationPaddingSection() {
    this.heightSection = this.offsetHeight;
    this.heightSection = this.heightSection < 18 ? 18 : this.heightSection > 96 ? 96 : this.heightSection;
    this.closest(".js-running-content").style.setProperty("--spacing-padding-block", this.heightSection + "px");
  }

  init() {
    this.distance = this.$(".js-marquee-item").offsetWidth;
    this.speed = this.dataset.speed;
    this.style.setProperty("--marquee-duration", `${this.distance / this.speed}s`);
    // this.calculationPaddingSection();
  }
}
customElements.define("sht-marquee", SHTMarquee);

if (!customElements.get("sht-sticky-compare")) {
  class SHTStickyCompare extends SHTCustomComponent {
    constructor() {
      super();
    }

    init() {
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.is_enabled = this.dataset.isEnabled;

      this.section_id = this.dataset.sectionId;

      this.current_scroll_top = 0;
      this.container_height = 0;
      this.sticky_bounds = {};
      this.style_sticky = window.getComputedStyle(this);
      this.style_sticky_margin_bottom = parseInt(this.style_sticky.marginBottom, 0);
      this.container = SHTHelper.qs(`#${this.section_id}`);
      this.footer_element = document.querySelector(".js-footer");
      this.container_padding_top = parseInt(window.getComputedStyle(this).getPropertyValue("padding-top"));

      this.bindEventHandlers();
    }

    bindEventHandlers() {
      window.addEventListener("scroll", this.onScrollHandle.bind(this), false);
    }

    onScrollHandle() {
      let maxScrollTop = document.documentElement.scrollHeight - document.documentElement.clientHeight;

      let intersection_point = this.footer_element !== null ? maxScrollTop - this.footer_element.offsetHeight : maxScrollTop + 10;

      let sticky_top = this.offsetTop + this.offsetHeight + this.style_sticky_margin_bottom + this.offsetTop + this.container_padding_top;

      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      let isBottom = Math.ceil(scrollTop) >= intersection_point ? true : false;
      let percent = 1 - sticky_top / scrollTop;

      if (scrollTop > this.current_scroll_top && percent >= 0 && !isBottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop > this.current_scroll_top && percent >= 0 && isBottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.current_scroll_top && percent >= 0 && !isBottom) {
        requestAnimationFrame(this.reveal.bind(this));
      }

      this.current_scroll_top = scrollTop;
    }

    connectedCallback() {
      this.init();
    }

    hide() {
      this.classList.remove("opacity-1");
      this.classList.add("hidden-xs", "opacity-0");
    }

    reveal() {
      this.classList.add("opacity-1");
      this.classList.remove("hidden-xs", "opacity-0");
    }
    reset() {
      this.classList.remove("opacity-1");
      this.classList.add("hidden-xs", "opacity-0");
    }
    /**
     * When the element is removed from the DOM, the disconnectedCallback method is triggered
     */
    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScrollHandle.bind(this));
    }

  }
  customElements.define("sht-sticky-compare", SHTStickyCompare)
}

if (!customElements.get("sht-dialog-compare")) {
  class SHTDialogCompare extends SHTDialogCore {
    constructor() {
      super();
    }

    init() {
      this.collectionCompare = SHTHelper.qs('.js-collections-compare');
      this.clearAllBtn = this.$('.js-btn-clear-all');
      this.btnShowProducts = this.$('.js-btn-compare');
      this.handleEventListeners();
    }

    connectedCallback() {
      this.init();
    }

    handleEventListeners() {
      const arraysProduct = this.getArrayFromLocalStorage();

      this.clearAllBtn.addEventListener("click", () => {
        this.collectionCompare.clearAllProducts(arraysProduct);
        this.collectionCompare.updateStickyCompare(0);
        this.body.innerHTML = '';
        localStorage.removeItem('sht-compare-product');
        this.closeModal();
      })

      this.btnShowProducts.addEventListener("click", () => {
        setTimeout(() => {
          this.setAttribute("hidden", true);
          this.classList.remove("is-active");
          this.body.innerHTML = "";
        }, 1000);
      })
    }

    showModal(opener) {
      SHTHelper.preventStickyHeaderReveal();
      this.opener = opener;
      this.opener?.setAttribute("disabled", "disabled");
      this.processData(opener);
      document.body.classList.add("o-hidden");
    }

    getArrayFromLocalStorage() {
      let arrayLocalStorage = localStorage.getItem('sht-compare-product');
      return JSON.parse(arrayLocalStorage);
    }

    fetchProductHTML(url) {
      return fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
          const productElement = responseHTML.querySelector(".section-product-compare");

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          return productElement.innerHTML;
        });
    }

    processData(opener) {
      const arraysProduct = this.getArrayFromLocalStorage();

      if (!arraysProduct) return;
      this.productElement = null;

      const urls = arraysProduct.map(product => `${product.url}?view=product-compare`);

      Promise.all(urls.map(url => this.fetchProductHTML(url).catch(error => {
        console.error(`Failed to fetch product from ${url}:`, error);
        return null;
      })))

        .then(productHTMLs => {


          this.body.innerHTML = '';

          productHTMLs.forEach((productHTML, index) => {

            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = productHTML;

            const productContainer = tempContainer.firstElementChild;

            const removeButton = document.createElement('button');
            removeButton.classList.add('btn', 'btn-link', 'btn-small', 'maw-fit-content', 'remove-product-button', 'js-remove-product-button');
            removeButton.textContent = 'Remove';
            productContainer.appendChild(removeButton);

            removeButton.addEventListener('click', () => {
              this.removeProduct(productContainer, removeButton);
            });
            this.body.appendChild(productContainer);

          });

          this.executeScriptElements(this.body);
          if (window.SHTProductMediaItemModel) {
            window.SHTProductMediaItemModel.loadShopifyXR();
          }
        })
        .catch(error => {
          console.error('One of the promises failed:', error);
        })
        .finally(() => {
          this.toggleAttribute("hidden", false);
          this.classList.add("is-active");
          this.opener?.removeAttribute("disabled");
        });
    }

    removeProduct(productContainer, removeButton) {
      const productId = removeButton.parentNode.dataset.product;

      productContainer.remove();

      let arraysProduct = this.getArrayFromLocalStorage();
      if (arraysProduct) {
        this.collectionCompare.removeStateProduct(productId);

        const productIndex = arraysProduct.findIndex(product => product.id === productId);
        if (productIndex !== -1) {
          arraysProduct.splice(productIndex, 1);
        }

        this.collectionCompare.updateLocalStorage(arraysProduct);
        this.collectionCompare.updateStickyCompare(arraysProduct.length);
      }

      if(arraysProduct.length == 0) this.closeModal();

    }

    closeModal() {
      this.setAttribute("hidden", true);
      this.classList.remove("is-active");
      document.body.classList.remove("o-hidden");

      setTimeout(() => {
        this.body.innerHTML = "";
      }, 100);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });
    }
  }
  customElements.define("sht-dialog-compare", SHTDialogCompare);
}
class SHTCollectionCompare extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.btnCompares = this.$$('.js-btn-add-to-compare');
    this.stickyCompare = SHTHelper.qs('.js-sticky-compare');
    this.productCounter = SHTHelper.qsa('.js-sticky-compare-counter');
    this.productsArray = this.getArrayFromLocalStorage() || [];
    this.btnShowProducts = SHTHelper.qs('.js-btn-compare');
    this.updateStatesProduct(this.productsArray);
    this.handleEvents();
  }

  handleEvents() {
    this.btnCompares.forEach((btn) => {
      btn.addEventListener('click', () => {

        this.productsArray = this.getArrayFromLocalStorage() || [];

        let productID = btn.getAttribute('data-product-id');
        let productUrl = btn.getAttribute('data-product-url');
        if (this.productsArray.length < 3) {
          this.addProductToArray(productID, productUrl);
          this.changeStateIcon(btn);
          this.updateStickyCompare(this.productsArray.length);
        } else {
          alert('You can only add a maximum of 3 products to compare.');
        }

      })

    })
  }

  addProductToArray(productID, ProductUrl) {
    let product = {id: productID, url: ProductUrl};

    if(!this.checkProductValid(productID, this.productsArray) || this.productsArray.length == 0) {
      this.productsArray.push(product);
      this.updateLocalStorage(this.productsArray);
    }
  }

  checkProductValid(productID, productsArray) {
    return productsArray.some(product => product.id === productID);
  }

  changeStateIcon(buttonIcon) {
    buttonIcon.closest('.js-product-card-wrapper').querySelectorAll('.js-btn-add-to-compare').forEach((btn) => {
      btn.classList.add('active');
    })
  }

  updateLocalStorage(products) {
    localStorage.setItem('sht-compare-product',JSON.stringify(products));
  }

  getArrayFromLocalStorage() {
    let arrayLocalStorage = localStorage.getItem('sht-compare-product');
    return JSON.parse(arrayLocalStorage);
  }

  updateStickyCompare(counter) {
    if (counter >= 1) {
      this.stickyCompare?.classList.remove('d-none-important');
    }
    else {
      this.stickyCompare?.classList.add('d-none-important');
    }

    if (counter == 1) {
      this.btnShowProducts?.setAttribute('disabled', 'disabled');
    } else {
      this.btnShowProducts?.removeAttribute('disabled');
    }

    this.productCounter.forEach((btn) => {
      btn.innerText = counter;
    })

  }

  updateStatesProduct (arraysProduct) {
    if (!arraysProduct) return;
    const arrayLength = arraysProduct.length;

    arraysProduct?.forEach((product) => {
      this.$$(`.js-btn-add-to-compare[data-product-id="${product.id}"]`).forEach((btn) => {
        btn.classList.add('active');
      })
    });

    this.updateStickyCompare(arrayLength);
  }

  clearAllProducts() {
    this.$$('.js-btn-add-to-compare').forEach((btn) => {
      btn.classList.remove('active');
    })
  }

  removeStateProduct(productId) {
    this.$$(`.js-btn-add-to-compare[data-product-id="${productId}"]`).forEach((btn) => {
      btn.classList.remove('active');
    })
  }

}
customElements.define("sht-collections-compare", SHTCollectionCompare);

if (!customElements.get("sht-dialog-show-products")) {
  class SHTShowProductsCompare extends SHTDialogCore{
    constructor() {
      super();
      this.collectionCompare = SHTHelper.qs('.js-collections-compare');
      this.btnShowProducts = this.$('.js-btn-compare');
      this.handleEventListeners();

    }

    handleEventListeners() {
      this.initResizeListener();
    }

    showModal(opener) {
      SHTHelper.preventStickyHeaderReveal();
      this.opener = opener;
      this.opener?.setAttribute("disabled", "disabled");
      document.body.classList.add("o-hidden");
      this.processData(opener);
    }

    getArrayFromLocalStorage() {
      let arrayLocalStorage = localStorage.getItem('sht-compare-product');
      return JSON.parse(arrayLocalStorage);
    }

    fetchProductHTML(url) {
      return fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
          const productElement = responseHTML.querySelector(".section-view-product-compare");

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          return productElement.innerHTML;
        });
    }

    processData(opener) {
      const arraysProduct = this.getArrayFromLocalStorage();
      this.body.style.setProperty('--block-size', arraysProduct.length);

      if (!arraysProduct) return;
      this.productElement = null;

      const urls = arraysProduct.map(product => `${product.url}?view=show-products-compare`);

      Promise.all(urls.map(url => this.fetchProductHTML(url)))

        .then(productHTMLs => {

          this.body.innerHTML = '';

          productHTMLs.forEach((productHTML, index) => {

            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = productHTML;

            const productContainer = tempContainer.firstElementChild;

            const buttonRemoveWrapper = productContainer.querySelector('.js-button-remove');

            const removeButton = document.createElement('button');
            removeButton.classList.add('btn', 'btn-link', 'btn-small', 'maw-fit-content', 'remove-product-button', 'js-remove-product-button');
            removeButton.textContent = 'Remove';
            buttonRemoveWrapper.appendChild(removeButton);

            removeButton.addEventListener('click', () => {
              this.removeProduct(productContainer, buttonRemoveWrapper);
            });

            this.body.appendChild(productContainer);
          });

          setTimeout(() => {
            this.calculateMaxHeightContents('.js-product-comparison-item');
            this.calculateMaxHeightContents('.js-product-comparison-variant');
            this.calculateMaxHeightContents('.js-product-comparison-des');
          }, 100);

          this.executeScriptElements(this.body);
          if (window.SHTProductMediaItemModel) {
            window.SHTProductMediaItemModel.loadShopifyXR();
          }
        })
        .catch(error => {
          console.error('Lỗi promise:', error);
        })
        .finally(() => {
          this.toggleAttribute("hidden", false);
          this.classList.add("is-active");
          this.opener?.removeAttribute("disabled");
        });
    }

    initResizeListener() {
      window.addEventListener('resize', () => {
        this.closeModal();
      });
    }

    calculateMaxHeightContents(selector) {
      const itemBlocks = this.body.querySelectorAll(selector);
      const heights = [];

      itemBlocks.forEach(item => {
        heights.push(item.clientHeight);
      });

      const maxHeight = Math.max(...heights);

      itemBlocks.forEach(item => {
        item.style.height = `${maxHeight}px`;
      });
    }

    removeProduct(productContainer, removeButton) {

      const productId = removeButton.dataset.product;

      console.log(productId);

      productContainer.remove();

      let arraysProduct = this.getArrayFromLocalStorage();
      if (arraysProduct) {
        this.collectionCompare.removeStateProduct(productId);

        const productIndex = arraysProduct.findIndex(product => product.id === productId);
        if (productIndex !== -1) {
          arraysProduct.splice(productIndex, 1);
        }

        this.collectionCompare.updateLocalStorage(arraysProduct);
        this.collectionCompare.updateStickyCompare(arraysProduct.length);
        this.body.style.setProperty('--block-size', arraysProduct.length);
      }

      if(arraysProduct.length == 1) this.closeModal();

    }

    closeModal() {
      this.setAttribute("hidden", true);
      this.classList.remove("is-active");
      document.body.classList.remove("o-hidden");

      setTimeout(() => {
        this.body.innerHTML = "";
      }, 10);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });
    }

  }
  customElements.define("sht-dialog-show-products", SHTShowProductsCompare);
}
class SHTPopup extends SHTCustomComponent {
  constructor() {
    super();
    this.sticky_popup = SHTHelper.qs("sht-sticky-popup");

    //this.$ = this.querySelector.bind(this);
    this.properties = JSON.parse(this.dataset.props);
    this.myStorage = window.sessionStorage;
    this.sessionStorageName = `${Shopify.theme.name.toLowerCase()}-popup-display`;
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.isOpen = false;
    // the pixels from bottom of scroll to fire your function. Can be 0
    this.buffer = 100;
    this.myScrollHeight =
      document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0;
    this.myWindowHeight = window.innerHeight || SHTHelper.qde.clientHeight || 0;
    this.elms = {
      close_btn: this.$(".js-popup-close-btn"),
      body: SHTHelper.qs("body"),
    };

    this.triggerOn = this.properties.triggerOn;
    this.timeOnPage = parseInt(this.properties.delayTime) * 1000;
    this.scrollEventHandle = this.onScrollEventHandle.bind(this);
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if(this.triggerOn === 'time-on-page') {
        let sitePopupStatus = this.getPopupStatus();
        if (!sitePopupStatus) {
          setTimeout(() => {
            this.togglePopup(true);
          }, this.timeOnPage);
        }
    }
    this.elms.close_btn.addEventListener(
      "click",
      this.onCloseBtnClickHandle.bind(this)
    );
    window.addEventListener("scroll", this.scrollEventHandle);

    if (
      this.cartNotification &&
      this.triggerOn === "after-closing-cart-notification"
    ) {
      this.cartNotification.addEventListener("closed", (e) => {
        let sitePopupStatus = this.getPopupStatus();
        if (!sitePopupStatus) {
          this.togglePopup(true);
        }
      });
    }
    this.popupAttrObserve();
  }
  onScrollEventHandle(evt) {
    if (this.triggerOn !== "reaching-to-footer") {
      window.removeEventListener("scroll", this.scrollEventHandle);
      return;
    }

    this.myScrollHeight =
      document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0;

    let scrollTop =
      window.pageYOffset ||
      SHTHelper.qde.scrollTop ||
      document.body.scrollTop ||
      0;

    let isOpen =
      scrollTop + this.buffer + this.myWindowHeight >= this.myScrollHeight
        ? true
        : false;

    let sitePopupStatus = this.getPopupStatus();

    if (
      this.triggerOn === "reaching-to-footer" &&
      isOpen &&
      (this.getAttribute("open") === null ||
        this.getAttribute("open") === "") &&
      !sitePopupStatus
    ) {
      this.togglePopup(true);
    }
  }
  /**
   * Toggle Site Popup
   *
   * @param boolean toggle
   * @returns
   */
  togglePopup(toggle) {
    if (toggle) {
      this.toggleOpen(true);
      if (this.properties.showSticky && this.sticky_popup) {
        this.sticky_popup.removeStickyPopupStatus();
      }
    } else {
      this.toggleOpen(false);
      this.setPopupStatus();
    }
  }

  toggleOpen(open) {
    if (open) {
      // this.style.maxHeight = `${this.scrollHeight}px`;
      this.style.setProperty("--height", `${this.clientHeight}px`);

      this.elms.body.classList.add("is-popup-show");
      this.setAttribute("open", true);
      //setTimeout(() => console.log(this.scrollHeight, this), 1000);
    } else {
      //this.style.maxHeight = `0px`;
      this.elms.body.classList.remove("is-popup-show");
      this.removeAttribute("open");
      SHTHelper.removeTrapFocus();
    }
    return;
  }

  onCloseBtnClickHandle(e) {
    e.preventDefault();
    if (this.properties.showSticky && this.sticky_popup) {
      let stickyPopupStatus = this.sticky_popup.getStickyPopupStatus();
      if (!stickyPopupStatus) {
        this.sticky_popup.openStickyPopup();
      }
    }
    this.togglePopup(false);
  }

  setPopupStatus() {
    this.myStorage.setItem(this.sessionStorageName, false);
  }

  getPopupStatus() {
    if (Shopify.designMode) {
      return "";
    } else {
      return this.myStorage.getItem(this.sessionStorageName);
    }
  }

  popupAttrObserve() {
    let popupAttrObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach(async (mutation) => {
        if (mutation.attributeName == "open") {
          const isOpen = this.hasAttribute("open");
          if (isOpen) {
            await this.animationsComplete();
            this.dispatchEvent(new Event("opened"));
            SHTHelper.trapFocus(this);
          } else {
            SHTHelper.removeTrapFocus();
            await this.animationsComplete();
            this.dispatchEvent(new Event("closed"));
          }
        }
      });
    });

    popupAttrObserver.observe(this, {
      attributes: true,
    });
  }

  animationsComplete() {
    return Promise.allSettled(
      this.getAnimations().map((animation) => animation.finished)
    );
  }

  removePopupStatus() {
    this.myStorage.removeItem(this.sessionStorageName);
  }
}

customElements.define("sht-popup", SHTPopup);

class SHTStickyPopup extends SHTCustomComponent {
  constructor() {
    super();
    this.myStorage = window.sessionStorage;
    this.popup = SHTHelper.qs("sht-popup");
    this.sessionStickyStorageName = `${Shopify.theme.name.toLowerCase()}-sticky-popup-display`;
    this.elms = {
      close_btn: this.$(".js-sticky-popup-close-btn"),
      open_popup_btn: this.$(".js-sticky-popup-reopen-btn"),
    };
    this.max_height = 0;
    this.init();
    this.bindEventHandlers();
  }

  init() {
    let status = this.getStickyPopupStatus();
    let popup_status = this.popup.getPopupStatus();
    if (status == null && popup_status == "false") {
      this.openStickyPopup();
    }
  }

  removeStickyPopupStatus() {
    this.myStorage.removeItem(this.sessionStickyStorageName);
  }

  bindEventHandlers() {
    this.elms.close_btn.addEventListener(
      "click",
      this.onCloseBtnClickHandle.bind(this)
    );

    this.elms.open_popup_btn.addEventListener(
      "click",
      this.onOpenPopupBtnClickHandle.bind(this)
    );
  }

  onOpenPopupBtnClickHandle(e) {
    e.preventDefault();
    this.popup.removePopupStatus();
    this.popup.togglePopup(true);
    this.hideStickyPopup();
  }

  onCloseBtnClickHandle(e) {
    e.preventDefault();
    this.closeStickyPopup();
  }

  setStickyPopupStatus() {
    this.myStorage.setItem(this.sessionStickyStorageName, false);
  }

  getStickyPopupStatus() {
    if (Shopify.designMode) {
      return "";
    } else {
      return this.myStorage.getItem(this.sessionStickyStorageName);
    }
  }

  closeStickyPopup() {
    this.classList.add("popup-sticky-hide");
    // this.style.maxHeight = `0px`;
    this.setStickyPopupStatus();
  }

  hideStickyPopup() {
    // this.style.maxHeight = `0px`;
    this.classList.add("popup-sticky-hide");
  }

  openStickyPopup() {
    // if (this.max_height < this.scrollHeight) {
    //   this.max_height = this.scrollHeight;
    // }
    // this.style.maxHeight = `${this.max_height}px`;

    this.style.setProperty("--height", `${this.clientHeight}px`);
    this.style.setProperty("--width", `${this.clientWidth}px`);
    this.classList.remove("popup-sticky-hide");
  }
}
customElements.define("sht-sticky-popup", SHTStickyPopup);

class SHTCountDown extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.isExpired = JSON.parse(this.dataset.isExpired);
    if (this.isExpired) return true;
    this.timeZoneName = this.dataset.timeZoneName;
    this.timeZoneOffset = this.dataset.timeZoneOffset;
    this.endTime = this.dataset.endTime;
    this.endDate = this.dataset.endDate;
    this.hideOnEnd = JSON.parse(this.dataset.hideOnEnd);

    if (!this.validateDateValue(this.endDate)) {
      this.endDate = this.getCurrentDateTime(true);
    }

    if (!this.validateTimeValue(this.endTime)) {
      this.endTime = "23:59:59";
    }

    this.expiredAt = new Date(this.convertDateStringToISOString(`${this.endDate}:${this.endTime}`)).getTime();
    this.currentTime = this.convertDateTimeToSpecificTimeZone(this.getCurrentDateTime());
    this.daysElement = this.$(".js-counter-days");
    this.hoursElement = this.$(".js-counter-hours");
    this.minutesElement = this.$(".js-counter-minutes");
    this.secondsElement = this.$(".js-counter-seconds");
    this.messageElement = this.$(".js-counter-message");
    this.counterElement = this.$(".js-counter");

    const interval = setInterval(() => {
      const diff = this.expiredAt - this.currentTime;
      if (diff <= 0) {
        clearInterval(interval);
        this.setCounter({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });

        if (this.messageElement.innerHTML != "") {
          this.messageElement.classList.remove("d-none");
        }

        if (this.hideOnEnd) {
          this.counterElement.classList.add("d-none-important");
        }

        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      this.setCounter({ days, hours, minutes, seconds });
      this.currentTime = this.currentTime + 1000;
    }, 1000);
  }

  connectedCallback() {
    this.init();
  }

  getCurrentDateTime(onlyDate = false) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();

    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    if (onlyDate) {
      return `${year}-${month}-${day}`;
    } else {
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }

  convertDateTimeToSpecificTimeZone(dateString, timestamp = true) {
    const inputDate = new Date(dateString);
    const isNegativeOffset = this.timeZoneOffset[0] === "-";
    const offsetHours = parseInt(this.timeZoneOffset.substring(1, 3));
    const offsetMinutes = parseInt(this.timeZoneOffset.substring(3, 5));
    let timeDifferenceMillis = (offsetHours * 60 + offsetMinutes) * 60 * 1000;
    if (isNegativeOffset) {
      timeDifferenceMillis = -timeDifferenceMillis;
    }
    const targetTime = new Date(inputDate.getTime() + timeDifferenceMillis);

    return timestamp ? targetTime.getTime() : targetTime.toISOString();
  }

  setCounter({ days, hours, minutes, seconds }) {
    this.daysElement.textContent = days < 10 ? `0${days}` : days;
    this.hoursElement.textContent = hours < 10 ? `0${hours}` : hours;
    this.minutesElement.textContent = minutes < 10 ? `0${minutes}` : minutes;
    this.secondsElement.textContent = seconds < 10 ? `0${seconds}` : seconds;
  }

  convertDateStringToISOString(inputDateStr) {
    const reformatDateStr = inputDateStr.replace(/:/, "T");
    return `${reformatDateStr}.000Z`;
  }

  validateDateValue(dateString) {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;

    if (datePattern.test(dateString)) {
      return true;
    } else {
      return false;
    }
  }

  validateTimeValue(timeString) {
    const timePattern = /^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;

    if (timePattern.test(timeString)) {
      return true;
    } else {
      return false;
    }
  }
}

customElements.define("sht-countdown", SHTCountDown);


class SHTProductComparisonVariantSelector extends SHTFeaturedVariantSelector {
  constructor() {
    super();
  }
  init() {
    this.elms = {
      radio_elms: this.$$(".js-featured-variant-radio-item"),
      form: SHTHelper.qs(`#productComparisonForm-${this.dataset.section}-${this.dataset.block}`),
      price: SHTHelper.qs(`#productComparisonPrice-${this.dataset.section}-${this.dataset.block}`),
      product_form: SHTHelper.qs(`sht-featured-prd-frm[data-section="${this.dataset.section}"]`),
      inventory_tracking: SHTHelper.qs(`#productComparisonInventoryTracking-${this.dataset.section}-${this.dataset.block}`),
      variant_picker: SHTHelper.qs(`#productComparisonVariantPicker-${this.dataset.section}-${this.dataset.block}`),
      slideshow: SHTHelper.qs(`sht-prd-slideshow[data-block="${this.dataset.block}"]`),
      variant_options: this.$$(".js-variant-option-value"),
    };

    this.price_selector = `#productComparisonPrice-${this.dataset.section}-${this.dataset.block}`;
    this.inventory_tracking_selector = `#productComparisonInventoryTracking-${this.dataset.section}-${this.dataset.block}`;
    this.variant_picker_selector = `#productComparisonVariantPicker-${this.dataset.section}-${this.dataset.block}`;

    this.slideshow_selector = `sht-prd-slideshow[data-section="${this.dataset.section}"]`;

    this.variantData = this.setSelectedVariants(this);

    this.updateSelectedVariants(this.variantData);
    this.bindEventHandlers();
  }
  setActiveMedia(variant) {
    if (variant.featured_media) {
      let mediaId = variant.featured_media.id;

      let activeMedia = this.elms.slideshow.querySelector(`sht-prd-comparison-itm[data-comparison="${this.dataset.block}-${mediaId}"]`);

      this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach(element => {
        element.classList.remove("d-block");
        this.elms.slideshow.hide_variant == "true" && element.classList.add("d-none");
      });

      this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });

      activeMedia.classList.add("d-block");
      this.elms.slideshow.hide_variant == "true" && activeMedia.classList.remove("d-none");

      this.elms.slideshow.pauseAllVideo();
    }
  }
}

class SHTProductComparisonVariantRadios extends SHTProductComparisonVariantSelector {
  constructor() {
    super();
  }

}
customElements.define("sht-product-comparison-variant-radios", SHTProductComparisonVariantRadios);

class SHTCartDiscount extends SHTCustomComponent {
  // Constants moved to class level for better memory usage
  static ENTER_KEY = 'Enter';
  static CART_UPDATE_DELAY = 500;
  static BIND_BUTTONS_DELAY = 600;
  static ENDPOINTS = {
    DISCOUNT: '/cart/update.js'
  };

  constructor() {
    super();
    this.initializeProperties();
    this.cacheElements();
    this.initializeState();
  }

  initializeProperties() {
    this.sectionId = this.dataset.sectionId;
    this.isUpdating = false;
    this.eventListeners = new Map(); // Better than Set for tracking
    this.debounceTimers = new Map(); // For debouncing operations
  }

  cacheElements() {
    // Cache all DOM elements once
    this.elements = {
      formDiv: this.querySelector('[data-discount-form]'),
      input: null, // Will be set after formDiv
      errorContainer: this.querySelector('#cartDiscountError'),
      successContainer: this.querySelector('#cartDiscountSuccess'),
      errorShipping: null, // Will be set after errorContainer
      errorDiscount: null,  // Will be set after errorContainer
      submitBtn: null, // Will be set after formDiv
      pillsContainer: this.querySelector('.js-discount-pills')
    };

    // Set dependent elements
    if (this.elements.formDiv) {
      this.elements.input = this.elements.formDiv.querySelector('.js-discount-input');
      this.elements.submitBtn = this.elements.formDiv.querySelector('.js-discount-submit');
    }

    if (this.elements.errorContainer) {
      this.elements.errorShipping = this.elements.errorContainer.querySelector('.js-error-shipping');
      this.elements.errorDiscount = this.elements.errorContainer.querySelector('.js-error-discount');
    }
  }

  initializeState() {
    // Bind methods once to avoid repeated binding
    this.boundHandlers = {
      handleDiscountSubmit: this.handleDiscountSubmit.bind(this),
      handleKeydown: this.handleKeydown.bind(this),
      handleFormSubmit: this.handleFormSubmit.bind(this),
      handleCartUpdate: this.handleCartUpdate.bind(this),
      handleDOMReady: this.handleDOMReady.bind(this),
      handleRemoveClick: this.handleRemoveClick.bind(this)
    };
  }

  connectedCallback() {
    this.setupEventListeners();
    this.bindRemoveButtons();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  setupEventListeners() {
    this.setupFormEvents();
    this.setupCartUpdateListener();
    this.setupRemoveButtonsDelegation();
  }

  setupFormEvents() {
    if (!this.elements.formDiv || this.elements.formDiv.dataset.eventBound) return;

    this.elements.formDiv.dataset.eventBound = 'true';

    // Submit button
    if (this.elements.submitBtn) {
      this.addEventListener(this.elements.submitBtn, 'click', this.boundHandlers.handleDiscountSubmit);
    }

    // Input field
    if (this.elements.input) {
      this.addEventListener(this.elements.input, 'keydown', this.boundHandlers.handleKeydown);
    }

    // Form submit prevention
    const mainForm = document.getElementById('cartForm');
    if (mainForm) {
      this.addEventListener(mainForm, 'submit', this.boundHandlers.handleFormSubmit);
    }
  }

  setupCartUpdateListener() {
    this.addEventListener(document, 'cart:update', this.boundHandlers.handleCartUpdate);
    
    // DOM ready handler
    if (document.readyState === 'loading') {
      this.addEventListener(document, 'DOMContentLoaded', this.boundHandlers.handleDOMReady);
    } else {
      this.boundHandlers.handleDOMReady();
    }
  }

  setupRemoveButtonsDelegation() {
    if (!this.elements.pillsContainer || this.elements.pillsContainer.dataset.delegationBound) return;
    
    this.elements.pillsContainer.dataset.delegationBound = 'true';
    this.addEventListener(this.elements.pillsContainer, 'click', this.boundHandlers.handleRemoveClick);
  }

  // Unified event listener management
  addEventListener(element, event, handler) {
    element.addEventListener(event, handler);
    
    const key = `${element.tagName}-${event}`;
    if (!this.eventListeners.has(key)) {
      this.eventListeners.set(key, []);
    }
    this.eventListeners.get(key).push({ element, event, handler });
  }

  removeEventListener(element, event, handler) {
    element.removeEventListener(event, handler);
    
    const key = `${element.tagName}-${event}`;
    const listeners = this.eventListeners.get(key);
    if (listeners) {
      const index = listeners.findIndex(l => l.element === element && l.handler === handler);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    }
  }

  // Event handlers
  handleKeydown(e) {
    if (e.key === SHTCartDiscount.ENTER_KEY) {
      e.preventDefault();
      this.handleDiscountSubmit(e);
    }
  }

  handleFormSubmit(e) {
    const activeElement = document.activeElement;
    if (this.isDiscountInputActive(activeElement)) {
      e.preventDefault();
      this.handleDiscountSubmit(e);
      return false;
    }
  }

  handleCartUpdate(event) {
    if (event.detail?.source === 'discount') {
      this.debounceBindRemoveButtons();
    }
  }

  handleDOMReady() {
    this.debounce('dom-ready', () => this.bindRemoveButtons(), 100);
  }

    handleRemoveClick(e) {
    const removeButton = e.target.closest('.js-remove-discount');
    if (!removeButton) return;

    e.preventDefault();
    e.stopPropagation();

    this.hideMessages();

    const discountCode = removeButton.dataset.removeDiscount;
    if (discountCode) {
      this.processDiscountRemoval(discountCode);
    }
  }

  // Debounce utility
  debounce(key, func, delay) {
    if (this.debounceTimers.has(key)) {
      clearTimeout(this.debounceTimers.get(key));
    }

    const timer = setTimeout(() => {
      func();
      this.debounceTimers.delete(key);
    }, delay);

    this.debounceTimers.set(key, timer);
  }

  debounceBindRemoveButtons() {
    // Single debounced call instead of multiple timeouts
    this.debounce('bind-buttons', () => this.bindRemoveButtons(), SHTCartDiscount.BIND_BUTTONS_DELAY);
  }

  isDiscountInputActive(element) {
    return element?.name === 'discount' && element.closest('[data-discount-form]');
  }

  bindRemoveButtons() {
    // Use more efficient selector and avoid repeated queries
    const removeButtons = document.querySelectorAll('.js-remove-discount:not([data-event-bound-remove])');
    
    if (removeButtons.length === 0) return;

    removeButtons.forEach(button => {
      const clickHandler = (e) => this.handleDiscountRemove(e);
      this.addEventListener(button, 'click', clickHandler);
      button.dataset.eventBoundRemove = 'true';
    });
  }

  async handleDiscountSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    const discountCode = this.getDiscountCodeFromInput();
    if (!discountCode) return;

    await this.processDiscountApplication(discountCode);
  }

  async handleDiscountRemove(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Ẩn thông báo khi xóa mã giảm giá
    this.hideMessages();

    const discountCode = e.currentTarget.dataset.removeDiscount;
    if (!discountCode) return;

    await this.processDiscountRemoval(discountCode);
  }

  getDiscountCodeFromInput() {
    return this.elements.input?.value.trim() || '';
  }

  async processDiscountApplication(discountCode) {
    this.setLoading(true);
    this.hideMessages();

    try {
      const existingDiscounts = this.getExistingDiscountCodes();
      const response = await this.applyDiscount(discountCode);

      if (!response.ok) {
        const errorData = await response.json();
        this.showError(errorData.description || 'discount_code');
        return;
      }

      const data = await response.json();
      const validationResult = this.validateDiscountResponse(data, existingDiscounts, discountCode);

      if (!validationResult.isValid) {
        this.clearInput();
        this.showError(validationResult.errorType);
        return;
      }

      this.handleSuccessfulDiscount();
    } catch (error) {
      console.error('Error applying discount:', error);
      this.showError('general');
    } finally {
      this.setLoading(false);
    }
  }

  async processDiscountRemoval(discountCode) {
    this.setLoading(true);

    this.hideMessages();

    try {
      const remainingCodes = this.getExistingDiscountCodes()
        .filter(code => code !== discountCode);

      const response = await this.sendDiscountUpdateRequest(remainingCodes);

      if (response.ok) {
        this.updateCartDrawer();
      }
    } catch (error) {
      console.error('Error removing discount:', error);
    } finally {
      this.setLoading(false);
    }
  }

  validateDiscountResponse(data, existingDiscounts, discountCode) {
    if (this.isDiscountNotApplicable(data, discountCode)) {
      return { isValid: false, errorType: 'discount_code' };
    }

    if (this.isShippingOnlyDiscount(data, existingDiscounts, discountCode)) {
      return { isValid: false, errorType: 'shipping' };
    }

    return { isValid: true };
  }

  isDiscountNotApplicable(data, discountCode) {
    return data.discount_codes?.some(discount =>
      discount.code === discountCode && discount.applicable === false
    );
  }

  isShippingOnlyDiscount(data, existingDiscounts, discountCode) {
    if (!data.sections?.[this.sectionId]) return false;

    const newDiscountCodes = this.extractDiscountCodesFromHTML(data.sections[this.sectionId]);
    return this.isDiscountAlreadyAppliedButNotVisible(
      newDiscountCodes,
      existingDiscounts,
      data.discount_codes,
      discountCode
    );
  }

  extractDiscountCodesFromHTML(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const section = doc.getElementById(`shopify-section-${this.sectionId}`);

    if (!section) return [];

    return Array.from(section.querySelectorAll('[data-discount-code]'))
      .map(el => el.dataset.discountCode)
      .filter(Boolean);
  }

  isDiscountAlreadyAppliedButNotVisible(newCodes, existingCodes, discountCodesData, discountCode) {
    const codesUnchanged = newCodes.length === existingCodes.length &&
                          newCodes.every(code => existingCodes.includes(code));

    const discountApplicable = discountCodesData?.some(discount =>
      discount.code === discountCode && discount.applicable === true
    );

    return codesUnchanged && discountApplicable;
  }

  async applyDiscount(code) {
    const existingCodes = this.getExistingDiscountCodes();
    const allCodes = [...existingCodes, code];
    return this.sendDiscountUpdateRequest(allCodes);
  }

  async sendDiscountUpdateRequest(codes) {
    return fetch(SHTCartDiscount.ENDPOINTS.DISCOUNT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: this.sectionId
      })
    });
  }

  getExistingDiscountCodes() {
    return Array.from(this.querySelectorAll('[data-discount-code]'))
      .map(el => el.dataset.discountCode)
      .filter(Boolean);
  }

  handleSuccessfulDiscount() {
    this.clearInput();
    this.showSuccess();
    this.updateCartDrawer();
  }

  clearInput() {
    if (this.elements.input) {
      this.elements.input.value = '';
    }
  }

  updateCartDrawer() {
    if (this.isUpdating) return;

    this.isUpdating = true;
    this.dispatchCartUpdateEvent();

    // Single debounced update instead of multiple timeouts
    this.debounce('cart-update', () => {
      this.bindRemoveButtons();
      this.isUpdating = false;
    }, SHTCartDiscount.CART_UPDATE_DELAY);
  }

  dispatchCartUpdateEvent() {
    document.dispatchEvent(new CustomEvent('cart:update', {
      detail: {
        source: 'discount',
        timestamp: Date.now()
      }
    }));
  }

  // UI State Management
  hideMessages() {
    this.hideError();
    this.hideSuccess();
  }

  showSuccess() {
    if (!this.elements.successContainer) return;
    this.hideError();
    this.elements.successContainer.classList.remove('d-none-important');
  }

  hideSuccess() {
    this.elements.successContainer?.classList.add('d-none-important');
  }

  showError(errorType) {
    if (!this.elements.errorContainer) return;

    this.hideSuccess();
    this.elements.errorContainer.classList.remove('d-none-important');
    this.toggleErrorTypes(errorType);
  }

  toggleErrorTypes(errorType) {
    const isShippingError = errorType === 'shipping';

    this.elements.errorShipping?.classList.toggle('d-none-important', !isShippingError);
    this.elements.errorDiscount?.classList.toggle('d-none-important', isShippingError);
  }

  hideError() {
    this.elements.errorContainer?.classList.add('d-none-important');
  }

  setLoading(isLoading) {
    this.toggleAttribute('loading', isLoading);
    this.elements.formDiv?.classList.toggle('loading', isLoading);
    this.elements.submitBtn?.toggleAttribute('disabled', isLoading);
  }

  cleanup() {
    // Clear all timers
    this.debounceTimers.forEach(timer => clearTimeout(timer));
    this.debounceTimers.clear();

    // Remove all event listeners
    this.eventListeners.forEach(listeners => {
      listeners.forEach(({ element, event, handler }) => {
        element.removeEventListener(event, handler);
      });
    });
    this.eventListeners.clear();
  }
}
customElements.define('sht-cart-discount', SHTCartDiscount);
